// @ts-nocheck
import { useState, useEffect, useRef, useMemo } from "react";
import { AMC_DOCTORS } from "./amc_doctors_data.js";
import { CMC_DOCTORS } from "./cmcseoul_doctors_data.js";
import { SNUH_DOCTORS } from "./snuh_doctors_data.js";
import { SMC_DOCTORS } from "./smc_doctors_data.js";
import { YUHS_DOCTORS } from "./yuhs_doctors_data.js";
import {
  saveRec,
  logSearch,
  registerWaitlist,
  registerOrRestoreUser,
  setPassword,
  loginWithPassword,
  saveMessage,
  getMyMessages,
  getTodayLunches,
  getCafeteriaNames,
  saveLunchMenu,
  reactToLunch,
  getMonthlyBest,
  getAllHospitalsBest,
  saveDoctorChangeRequest,
} from "./firebase.js";
if (typeof window !== "undefined") window._logSearch = logSearch;

const H = {
  amc: { id: "amc", name: "서울아산병원", short: "아산병원", color: "#6366f1" },
  snuh: {
    id: "snuh",
    name: "서울대학교병원",
    short: "서울대병원",
    color: "#3b82f6",
  },
  smc: { id: "smc", name: "삼성서울병원", short: "삼성병원", color: "#8b5cf6" },
  yuhs: {
    id: "yuhs",
    name: "신촌세브란스병원",
    short: "세브란스",
    color: "#06b6d4",
  },
  cmcseoul: {
    id: "cmcseoul",
    name: "서울성모병원",
    short: "성모병원",
    color: "#2563eb",
  },
};

const OTHER_DOCS = [];
const ALL_DOCS = [
  ...AMC_DOCTORS.map((d) => ({
    ...d,
    hid: "amc",
    recs: d.recs || { dr: 0, nr: 0, mt: 0, ad: 0 },
  })),
  ...CMC_DOCTORS.map((d) => ({
    ...d,
    recs: d.recs || { dr: 0, nr: 0, mt: 0, ad: 0 },
  })),
  ...SNUH_DOCTORS.map((d) => ({
    ...d,
    recs: d.recs || { dr: 0, nr: 0, mt: 0, ad: 0 },
  })),
  ...SMC_DOCTORS.map((d) => ({
    ...d,
    recs: d.recs || { dr: 0, nr: 0, mt: 0, ad: 0 },
  })),
  ...YUHS_DOCTORS.map((d) => ({
    ...d,
    recs: d.recs || { dr: 0, nr: 0, mt: 0, ad: 0 },
  })),
  ...OTHER_DOCS,
];

const ROLES = [
  { l: "의사", n: 18 },
  { l: "간호사", n: 167 },
  { l: "의료기사", n: 54 },
  { l: "기타", n: 31 },
];
function totalRec(r) {
  return (r.dr || 0) + (r.nr || 0) + (r.mt || 0) + (r.ad || 0);
}

// 현재 기간 정보 (1~6월 = 상반기, 7~12월 = 하반기)
function getCurrentPeriod() {
  const now = new Date();
  const year = now.getFullYear();
  const isFirstHalf = now.getMonth() < 6;
  return {
    year,
    isFirstHalf,
    label: isFirstHalf
      ? `${year}년 상반기 (1~6월)`
      : `${year}년 하반기 (7~12월)`,
    shortLabel: isFirstHalf ? "상반기" : "하반기",
    deadline: isFirstHalf ? "6월 30일" : "12월 31일",
    key: isFirstHalf ? `changed_${year}_h1` : `changed_${year}_h2`,
  };
}

// 시간대별 인사말
// 시간대별 메시지 모음 (각 시간대마다 랜덤 선택)
const TIME_GREETINGS = {
  dawn: [
    // 새벽 (0~6시)
    "엇! 이 시간에 어쩐 일로?",
    "출출하세요? 🍪",
    "오늘 메뉴 궁금해서 일찍 오셨나요? 😊",
    "혹시 야간 근무? 그렇다면 화이팅입니다요! 🌙",
    "벌써 출근 준비????",
  ],
  morning: [
    // 오전 (6~11시)
    "오늘도 화이팅입니다 💪",
    "아침 드셨어요? 🍞",
    "즐거운 하루 되세요 🌼",
    "오늘 메뉴 마음에 드시나요? 🤔",
    "좋은 기운 드립니다~~ ✨",
  ],
  lunch: [
    // 점심 (11~16시, 병원 점심 시간 폭 반영)
    "오늘의 점심! 만족? 😋",
    "드디어 밥시간!! 🎉",
    "맛있게 드시고 재충전! ⚡",
    "먹어도 먹어도 배고프다 😅",
    "내일은 더 맛난 거 주세요~!! 🙏",
  ],
  evening: [
    // 저녁/야간 (16~24시)
    "오늘 저녁도 병원 식당? 🍽️",
    "저녁 메뉴 만족? 😋",
    "좋은 오후/저녁 되세요 ✨",
    "설마 점심 못 드신 건 아니죠? 😮",
    "오늘은 오늘! 내일은 내일! ✨",
  ],
};

function getTimeGreeting() {
  const hour = new Date().getHours();
  let pool;
  if (hour < 6) pool = TIME_GREETINGS.dawn;
  else if (hour < 11) pool = TIME_GREETINGS.morning;
  else if (hour < 16) pool = TIME_GREETINGS.lunch;
  else pool = TIME_GREETINGS.evening;
  return pool[Math.floor(Math.random() * pool.length)];
}

// 등록 완료 메시지 (랜덤)
const FIRST_MESSAGES = [
  "짝짝짝! 오늘의 메뉴를 공유해주셔서 감사합니다 🎉",
  "👑 오늘의 1호! 동료들이 고마워하고 있어요",
  "🎊 첫 번째 정보 감사합니다! 모두가 기다리고 있었어요",
];
const ADD_MESSAGES = [
  "좋은 정보 감사합니다 🙌",
  "동료들에게 도움이 될 거예요 ✨",
  "추가 정보 고마워요!",
];
const pickRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

function Cross({ size = 16, color = "#a5b4fc" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <rect x="8.5" y="2" width="3" height="16" rx="1.5" fill={color} />
      <rect x="2" y="8.5" width="16" height="3" rx="1.5" fill={color} />
    </svg>
  );
}

function ThumbIcon({ filled, size = 12, color }) {
  const s = color || "#6366f1";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? s : "none"}
      stroke={s}
      strokeWidth="2"
    >
      <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z" />
      <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
    </svg>
  );
}

function HBadge({ hid }) {
  const h = H[hid];
  if (!h) return null;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "2px 8px",
        borderRadius: 20,
        background: `${h.color}18`,
        border: `0.5px solid ${h.color}35`,
        fontSize: 10,
        fontWeight: 700,
        color: h.color,
        whiteSpace: "nowrap",
      }}
    >
      <span
        style={{
          width: 4,
          height: 4,
          borderRadius: "50%",
          background: h.color,
        }}
      />
      {h.short}
    </span>
  );
}

function Avatar({ photo, color, hid, size = 44 }) {
  const [err, setErr] = useState(false);
  const show = photo && !err && !photo.includes("default");
  const abbr = {
    amc: "AMC",
    snuh: "SNUH",
    smc: "SMC",
    yuhs: "세브란스",
    cmcseoul: "CMC",
  };
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.3,
        background: `${color}15`,
        border: `0.5px solid ${color}28`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        overflow: "hidden",
      }}
    >
      {show ? (
        <img
          src={photo}
          alt=""
          onError={() => setErr(true)}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        <span
          style={{
            fontSize: size * 0.2,
            fontWeight: 900,
            color,
            letterSpacing: -0.5,
          }}
        >
          {abbr[hid] || "+"}
        </span>
      )}
    </div>
  );
}

function RecBars({ recs }) {
  const t = totalRec(recs);
  const bars = [
    { k: "nr", l: "간호사", c: "#60a5fa" },
    { k: "dr", l: "의사", c: "#34d399" },
    { k: "mt", l: "의료기사", c: "#a78bfa" },
    { k: "ad", l: "기타", c: "#fbbf24" },
  ];
  if (!t) return null;
  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: 2,
          height: 5,
          borderRadius: 3,
          overflow: "hidden",
          marginBottom: 6,
        }}
      >
        {bars.map((b) => (
          <div key={b.k} style={{ flex: recs[b.k] / t, background: b.c }} />
        ))}
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {bars.map((b) => (
          <span
            key={b.k}
            style={{
              fontSize: 11,
              color: "#64748b",
              display: "flex",
              alignItems: "center",
              gap: 3,
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: b.c,
                display: "inline-block",
              }}
            />
            {b.l} <strong style={{ color: "#94a3b8" }}>{recs[b.k]}</strong>
          </span>
        ))}
      </div>
    </div>
  );
}

function SearchInput({ value, onChange, onClear, onSearch }) {
  const ref = useRef(null);
  const composing = useRef(false);
  const timer = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const fire = (v) => {
      onChange(v);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        if (v.trim().length >= 2 && onSearch) onSearch(v.trim());
      }, 1000);
    };
    const onStart = () => {
      composing.current = true;
    };
    const onEnd = (e) => {
      composing.current = false;
      fire(e.target.value);
    };
    const onInput = (e) => {
      if (!composing.current) fire(e.target.value);
    };
    el.addEventListener("compositionstart", onStart);
    el.addEventListener("compositionend", onEnd);
    el.addEventListener("input", onInput);
    return () => {
      el.removeEventListener("compositionstart", onStart);
      el.removeEventListener("compositionend", onEnd);
      el.removeEventListener("input", onInput);
    };
  }, [onChange, onSearch]);
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        background: "rgba(0,0,0,0.04)",
        border: "0.5px solid rgba(255,255,255,0.1)",
        borderRadius: 12,
        padding: "10px 14px",
        marginBottom: 10,
      }}
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#6366f1"
        strokeWidth="2"
      >
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35" />
      </svg>
      <input
        ref={ref}
        defaultValue={value}
        placeholder="이름, 진료과, 전문분야 검색..."
        style={{
          background: "none",
          border: "none",
          outline: "none",
          color: "#1e293b",
          fontSize: 14,
          flex: 1,
          fontFamily: "inherit",
        }}
      />
      {value && (
        <button
          onClick={onClear}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            color: "#475569",
            display: "flex",
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </button>
      )}
    </div>
  );
}

function RecModal({
  doc,
  nick,
  uuid,
  onClose,
  onDone,
  onThankYou,
  isAlreadyDone,
  prevThumbs,
  hasChanged,
}) {
  const h = H[doc.hid] || H.amc;
  const [thumbs, setThumbs] = useState(prevThumbs || 0);
  const [note, setNote] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (prevThumbs > 0) setThumbs(prevThumbs);
  }, [prevThumbs]);

  const period = getCurrentPeriod();
  const alreadyChanged = hasChanged;
  const canChange = isAlreadyDone && !alreadyChanged;
  const isDisabled = isAlreadyDone && alreadyChanged;
  const isCancelling = isAlreadyDone && thumbs === 0;
  const canSubmit =
    !isDisabled &&
    (isCancelling || (thumbs >= 1 && (thumbs < 5 || note.trim().length > 0)));

  const submit = async () => {
    if (!canSubmit) return;
    setDone(true);
    try {
      if (isAlreadyDone) {
        const { db } = await import("./firebase.js");
        const { collection, query, where, getDocs, updateDoc } = await import(
          "firebase/firestore"
        );
        const q2 = query(
          collection(db, "recommendations"),
          where("uuid", "==", uuid),
          where("docId", "==", doc.i)
        );
        const snap = await getDocs(q2);
        if (!snap.empty) {
          await updateDoc(snap.docs[0].ref, {
            thumbs,
            note,
            [period.key]: true,
          });
        }
      } else {
        await saveRec(
          doc.i,
          doc.n,
          doc.de,
          doc.s || [],
          doc.hid,
          uuid || "anonymous",
          nick || "익명",
          thumbs,
          [],
          note,
          window._lastSearch || ""
        );
      }
    } catch (e) {
      console.error("저장 실패:", e);
    }
  };

  if (done)
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.88)",
          zIndex: 300,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 420,
            background: "#fff",
            borderRadius: "20px 20px 0 0",
            padding: "2rem 1.5rem 3rem",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              background: `${h.color}18`,
              border: `0.5px solid ${h.color}40`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
            }}
          >
            <ThumbIcon filled size={28} color={h.color} />
          </div>
          <p
            style={{
              fontSize: 16,
              fontWeight: 700,
              color: "#1e293b",
              margin: "0 0 6px",
            }}
          >
            {isAlreadyDone ? "추천이 변경되었습니다" : "추천이 등록되었습니다"}
          </p>
          <p style={{ fontSize: 12, color: "#475569", margin: "0 0 24px" }}>
            {period.label} 집계에 반영됩니다
          </p>
          <p
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#1e293b",
              margin: "0 0 16px",
            }}
          >
            계속 추천하시겠습니까?
          </p>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              onClick={() => {
                onDone(thumbs, isAlreadyDone);
                onThankYou && onThankYou();
              }}
              style={{
                flex: 1,
                padding: "12px 0",
                borderRadius: 12,
                border: "0.5px solid rgba(0,0,0,0.1)",
                background: "none",
                color: "#64748b",
                fontWeight: 700,
                fontSize: 14,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              아니오
            </button>
            <button
              onClick={() => {
                onDone(thumbs, isAlreadyDone);
                onClose();
              }}
              style={{
                flex: 1,
                padding: "12px 0",
                borderRadius: 12,
                border: "none",
                background: `linear-gradient(135deg,${h.color},#6366f1)`,
                color: "#fff",
                fontWeight: 700,
                fontSize: 14,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              예
            </button>
          </div>
        </div>
      </div>
    );

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.88)",
        zIndex: 300,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: "20px 20px 0 0",
          padding: "1.5rem 1.5rem 3rem",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 18,
          }}
        >
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "#64748b",
              fontSize: 13,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            ← 목록으로
          </button>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Avatar photo={""} color={h.color} hid={doc.hid} size={30} />
            <div>
              <p
                style={{
                  margin: 0,
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#1e293b",
                }}
              >
                {doc.n}
              </p>
              <p style={{ margin: 0, fontSize: 11, color: "#64748b" }}>
                {doc.de} · {h.short}
              </p>
            </div>
          </div>
        </div>

        <div
          style={{
            background: "rgba(96,165,250,0.06)",
            border: "0.5px solid rgba(96,165,250,0.2)",
            borderRadius: 11,
            padding: "8px 13px",
            marginBottom: 16,
          }}
        >
          <p style={{ margin: 0, fontSize: 11, color: "#60a5fa" }}>
            📅 {period.label} · 발표일은 별도 공지됩니다
          </p>
        </div>

        {isAlreadyDone && canChange && (
          <div
            style={{
              background: "rgba(99,102,241,0.08)",
              border: "0.5px solid rgba(99,102,241,0.2)",
              borderRadius: 11,
              padding: "10px 13px",
              marginBottom: 16,
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: 12,
                color: "#6366f1",
                fontWeight: 600,
              }}
            >
              이미 추천하셨습니다 — {period.deadline}까지 1회 변경 가능합니다
            </p>
          </div>
        )}

        {isDisabled && (
          <div
            style={{
              background: "rgba(251,191,36,0.08)",
              border: "0.5px solid rgba(251,191,36,0.3)",
              borderRadius: 11,
              padding: "10px 13px",
              marginBottom: 16,
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: 12,
                color: "#d97706",
                fontWeight: 600,
              }}
            >
              이번 {period.shortLabel} 변경 횟수를 모두 사용했습니다
            </p>
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 10,
            marginBottom: 20,
            opacity: isDisabled ? 0.4 : 1,
            pointerEvents: isDisabled ? "none" : "auto",
          }}
        >
          {[1, 2, 3, 4, 5].map((i) => (
            <button
              key={i}
              onClick={() => setThumbs(thumbs === i ? 0 : i)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 4,
              }}
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 24 24"
                fill={i <= thumbs ? h.color : "none"}
                stroke={i <= thumbs ? h.color : "rgba(0,0,0,0.2)"}
                strokeWidth="1.8"
              >
                <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z" />
                <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
              </svg>
            </button>
          ))}
        </div>

        <p
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#475569",
            letterSpacing: ".1em",
            marginBottom: 7,
          }}
        >
          추천 사유{" "}
          {thumbs === 5 ? (
            <span style={{ color: "#f43f5e" }}>* 필수</span>
          ) : (
            <span style={{ color: "#94a3b8", fontWeight: 400 }}>(선택)</span>
          )}
        </p>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="직접 경험한 추천 이유를 남겨주세요"
          rows={3}
          disabled={isDisabled}
          style={{
            width: "100%",
            boxSizing: "border-box",
            background: "rgba(0,0,0,0.03)",
            border: "0.5px solid rgba(0,0,0,0.08)",
            borderRadius: 11,
            padding: "11px 13px",
            color: "#1e293b",
            fontSize: 13,
            fontFamily: "inherit",
            resize: "none",
            outline: "none",
            marginBottom: 16,
            opacity: isDisabled ? 0.4 : 1,
          }}
        />

        {!isDisabled && (
          <>
            <button
              disabled={!canSubmit}
              onClick={submit}
              style={{
                width: "100%",
                padding: "14px 0",
                borderRadius: 13,
                border: "none",
                fontWeight: 700,
                fontSize: 14,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 7,
                fontFamily: "inherit",
                background: canSubmit
                  ? `linear-gradient(135deg,${h.color},#6366f1)`
                  : "rgba(99,102,241,0.15)",
                color: canSubmit ? "#fff" : "#475569",
                cursor: canSubmit ? "pointer" : "not-allowed",
              }}
            >
              <ThumbIcon
                filled={canSubmit}
                size={14}
                color={canSubmit ? "#fff" : "#475569"}
              />
              {isAlreadyDone
                ? thumbs === 0
                  ? "추천 취소하기"
                  : "추천 변경하기"
                : "추천 등록하기"}
            </button>
            {isAlreadyDone && thumbs === 0 && (
              <p
                style={{
                  fontSize: 11,
                  color: "#94a3b8",
                  textAlign: "center",
                  marginTop: 8,
                }}
              >
                엄지척 없이 제출하면 추천이 취소됩니다
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// 점심 메뉴 화면
// ─────────────────────────────────────────────
function LunchScreen({ hospital, uuid, nick }) {
  const h = H[hospital] || H.amc;
  const [lunches, setLunches] = useState([]);
  const [cafeterias, setCafeterias] = useState([]);
  const [monthlyBest, setMonthlyBest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [doneMsg, setDoneMsg] = useState(null);
  const [showAllBest, setShowAllBest] = useState(false);

  const loadAll = async () => {
    setLoading(true);
    try {
      const [list, names, best] = await Promise.all([
        getTodayLunches(hospital),
        getCafeteriaNames(hospital),
        getMonthlyBest(hospital),
      ]);
      setLunches(list);
      setCafeterias(names);
      setMonthlyBest(best);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadAll();
  }, [hospital]);

  const handleReact = async (lunchId, reaction) => {
    try {
      await reactToLunch(lunchId, uuid, reaction);
      await loadAll();
    } catch (e) {
      console.error(e);
    }
  };

  if (doneMsg) {
    const isFirst = doneMsg.isFirst;
    return (
      <div style={{ textAlign: "center", padding: "40px 20px" }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>
          {isFirst ? "🎊" : "🙌"}
        </div>
        <p
          style={{
            fontSize: 17,
            fontWeight: 800,
            color: "#1e293b",
            margin: "0 0 8px",
            lineHeight: 1.5,
          }}
        >
          {isFirst ? pickRandom(FIRST_MESSAGES) : pickRandom(ADD_MESSAGES)}
        </p>
        <div
          style={{
            width: 40,
            height: 1,
            background: "rgba(0,0,0,0.1)",
            margin: "20px auto",
          }}
        />
        <p
          style={{
            fontSize: 14,
            color: "#64748b",
            margin: "0 0 28px",
            lineHeight: 1.6,
          }}
        >
          {getTimeGreeting()}
        </p>
        <button
          onClick={() => {
            setDoneMsg(null);
            loadAll();
          }}
          style={{
            padding: "12px 32px",
            borderRadius: 12,
            border: "none",
            background: `linear-gradient(135deg,${h.color},#6366f1)`,
            color: "#fff",
            fontWeight: 700,
            fontSize: 14,
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          확인
        </button>
      </div>
    );
  }

  if (showAdd) {
    return (
      <LunchAddModal
        hospital={hospital}
        uuid={uuid}
        nick={nick}
        cafeterias={cafeterias}
        onClose={() => setShowAdd(false)}
        onDone={(result) => {
          setShowAdd(false);
          setDoneMsg({ isFirst: result.isFirst });
        }}
      />
    );
  }

  if (loading) {
    return (
      <p
        style={{
          color: "#94a3b8",
          textAlign: "center",
          padding: "30px 0",
          fontSize: 13,
        }}
      >
        불러오는 중...
      </p>
    );
  }

  const today = new Date();
  const dateStr = `${today.getFullYear()}년 ${
    today.getMonth() + 1
  }월 ${today.getDate()}일`;
  const dayNames = ["일", "월", "화", "수", "목", "금", "토"];
  const dayStr = `${dayNames[today.getDay()]}요일`;

  return (
    <>
      <div style={{ marginBottom: 14 }}>
        <p style={{ margin: "0 0 4px", fontSize: 11, color: "#94a3b8" }}>
          {dateStr} {dayStr}
        </p>
        <h2
          style={{ margin: 0, fontSize: 18, fontWeight: 800, color: "#1e293b" }}
        >
          🍱 오늘의 메뉴
        </h2>
      </div>

      {/* 이번 달 베스트 메뉴 카드 */}
      {monthlyBest && (
        <div
          style={{
            background: `linear-gradient(135deg,${h.color}10,rgba(251,191,36,0.08))`,
            border: `0.5px solid ${h.color}30`,
            borderRadius: 16,
            padding: "16px 18px",
            marginBottom: 14,
          }}
        >
          <p
            style={{
              margin: "0 0 12px",
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: ".1em",
              color: h.color,
            }}
          >
            🏆 이번 달 베스트 메뉴
          </p>
          <p
            style={{
              margin: "0 0 4px",
              fontSize: 18,
              fontWeight: 800,
              color: "#1e293b",
            }}
          >
            {monthlyBest.menu}
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 14,
            }}
          >
            <span style={{ fontSize: 13, fontWeight: 700, color: h.color }}>
              👍 {monthlyBest.likes}
            </span>
            {monthlyBest.cafeteria && (
              <span style={{ fontSize: 12, color: "#64748b" }}>
                {monthlyBest.cafeteria}
              </span>
            )}
          </div>
          <button
            onClick={() => setShowAllBest(true)}
            style={{
              width: "100%",
              padding: "10px 0",
              borderRadius: 10,
              border: "0.5px solid rgba(0,0,0,0.1)",
              background: "rgba(255,255,255,0.6)",
              color: "#475569",
              fontWeight: 700,
              fontSize: 12,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            🔍 다른 병원은 뭐 먹나요?
          </button>
        </div>
      )}

      {lunches.length === 0 ? (
        <div
          style={{
            background: `linear-gradient(135deg,${h.color}10,rgba(96,165,250,0.08))`,
            border: `0.5px solid ${h.color}30`,
            borderRadius: 16,
            padding: "30px 20px",
            textAlign: "center",
            marginBottom: 14,
          }}
        >
          <div style={{ fontSize: 42, marginBottom: 12 }}>🥇</div>
          <p
            style={{
              fontSize: 15,
              fontWeight: 700,
              color: "#1e293b",
              margin: "0 0 6px",
            }}
          >
            아직 등록된 메뉴가 없어요
          </p>
          <p
            style={{
              fontSize: 13,
              color: "#64748b",
              margin: "0 0 20px",
              lineHeight: 1.6,
            }}
          >
            오늘의 1호가 되어보세요!
            <br />
            동료들이 궁금해하고 있어요 👀
          </p>
          <button
            onClick={() => setShowAdd(true)}
            style={{
              padding: "12px 28px",
              borderRadius: 12,
              border: "none",
              background: `linear-gradient(135deg,${h.color},#6366f1)`,
              color: "#fff",
              fontWeight: 700,
              fontSize: 14,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            📷 메뉴 올리기
          </button>
        </div>
      ) : (
        <>
          <p style={{ fontSize: 11, color: "#475569", marginBottom: 12 }}>
            <span style={{ color: h.color, fontWeight: 700 }}>
              {lunches.length}개
            </span>
            의 메뉴가 공유되었어요
          </p>

          {lunches.map((l) => {
            const isMyLike = (l.likedBy || []).includes(uuid);
            const isMySoso = (l.sosoBy || []).includes(uuid);
            const time = l.createdAt?.toDate?.();
            const timeStr = time
              ? `${String(time.getHours()).padStart(2, "0")}:${String(
                  time.getMinutes()
                ).padStart(2, "0")}`
              : "";
            return (
              <div
                key={l.id}
                style={{
                  background: "rgba(0,0,0,0.03)",
                  border: `0.5px solid ${
                    l.isFirstOfDay ? h.color + "40" : "rgba(0,0,0,0.07)"
                  }`,
                  borderRadius: 16,
                  padding: 14,
                  marginBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: 10,
                  }}
                >
                  <div style={{ flex: 1, minWidth: 0 }}>
                    {l.cafeteria && (
                      <p
                        style={{
                          margin: "0 0 4px",
                          fontSize: 13,
                          fontWeight: 700,
                          color: "#1e293b",
                        }}
                      >
                        🍽️ {l.cafeteria}
                      </p>
                    )}
                    <p
                      style={{
                        margin: "0 0 8px",
                        fontSize: 14,
                        color: "#1e293b",
                        lineHeight: 1.5,
                      }}
                    >
                      {l.menu}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        flexWrap: "wrap",
                      }}
                    >
                      {l.isFirstOfDay && (
                        <span
                          style={{
                            fontSize: 10,
                            padding: "2px 8px",
                            borderRadius: 20,
                            background: `${h.color}18`,
                            color: h.color,
                            fontWeight: 700,
                            border: `0.5px solid ${h.color}40`,
                          }}
                        >
                          🥇 오늘의 1호
                        </span>
                      )}
                      <span style={{ fontSize: 11, color: "#94a3b8" }}>
                        {l.uploaderNick} · {timeStr}
                      </span>
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
                  <button
                    onClick={() => handleReact(l.id, "like")}
                    style={{
                      flex: 1,
                      padding: "9px 0",
                      borderRadius: 10,
                      border: `0.5px solid ${
                        isMyLike ? h.color + "40" : "rgba(0,0,0,0.08)"
                      }`,
                      background: isMyLike
                        ? `${h.color}14`
                        : "rgba(0,0,0,0.02)",
                      color: isMyLike ? h.color : "#475569",
                      fontWeight: isMyLike ? 700 : 600,
                      fontSize: 13,
                      cursor: "pointer",
                      fontFamily: "inherit",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 5,
                    }}
                  >
                    👍 맛있어요 {l.likes > 0 && <strong>{l.likes}</strong>}
                  </button>
                  <button
                    onClick={() => handleReact(l.id, "soso")}
                    style={{
                      flex: 1,
                      padding: "9px 0",
                      borderRadius: 10,
                      border: `0.5px solid ${
                        isMySoso ? "#94a3b8" : "rgba(0,0,0,0.08)"
                      }`,
                      background: isMySoso
                        ? "rgba(148,163,184,0.15)"
                        : "rgba(0,0,0,0.02)",
                      color: isMySoso ? "#475569" : "#94a3b8",
                      fontWeight: isMySoso ? 700 : 600,
                      fontSize: 13,
                      cursor: "pointer",
                      fontFamily: "inherit",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 5,
                    }}
                  >
                    😐 그저그래요 {l.soso > 0 && <strong>{l.soso}</strong>}
                  </button>
                </div>
              </div>
            );
          })}

          <button
            onClick={() => setShowAdd(true)}
            style={{
              width: "100%",
              padding: "12px 0",
              borderRadius: 12,
              border: `0.5px dashed ${h.color}50`,
              background: `${h.color}06`,
              color: h.color,
              fontWeight: 700,
              fontSize: 13,
              cursor: "pointer",
              fontFamily: "inherit",
              marginTop: 6,
            }}
          >
            + 다른 식당 메뉴 추가하기
          </button>
        </>
      )}

      {showAllBest && (
        <AllHospitalsBestModal onClose={() => setShowAllBest(false)} />
      )}
    </>
  );
}

// 빅5 병원 베스트 메뉴 모달
function AllHospitalsBestModal({ onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllHospitalsBest()
      .then((r) => {
        setData(r);
        setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  const now = new Date();
  const monthStr = `${now.getFullYear()}년 ${now.getMonth() + 1}월`;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.88)",
        zIndex: 300,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: "20px 20px 0 0",
          padding: "1.5rem 1.5rem 3rem",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 14,
          }}
        >
          <div>
            <p style={{ margin: "0 0 4px", fontSize: 11, color: "#94a3b8" }}>
              {monthStr}
            </p>
            <h3
              style={{
                margin: 0,
                fontSize: 17,
                fontWeight: 800,
                color: "#1e293b",
              }}
            >
              🏆 빅5 베스트 메뉴
            </h3>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "rgba(0,0,0,0.04)",
              border: "none",
              borderRadius: 8,
              padding: 7,
              cursor: "pointer",
              fontSize: 16,
            }}
          >
            ✕
          </button>
        </div>

        <p style={{ fontSize: 12, color: "#64748b", margin: "0 0 18px" }}>
          각 병원에서 가장 많은 👍를 받은 메뉴예요
        </p>

        {loading ? (
          <p
            style={{
              color: "#94a3b8",
              textAlign: "center",
              padding: "30px 0",
              fontSize: 13,
            }}
          >
            불러오는 중...
          </p>
        ) : (
          <>
            {(data || []).map(({ hospital: hid, best }) => {
              const hi = H[hid];
              return (
                <div
                  key={hid}
                  style={{
                    background: "rgba(0,0,0,0.03)",
                    border: `0.5px solid ${hi.color}25`,
                    borderRadius: 14,
                    padding: 14,
                    marginBottom: 10,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      marginBottom: 8,
                    }}
                  >
                    <span
                      style={{
                        width: 7,
                        height: 7,
                        borderRadius: "50%",
                        background: hi.color,
                        flexShrink: 0,
                      }}
                    />
                    <p
                      style={{
                        margin: 0,
                        fontSize: 13,
                        fontWeight: 700,
                        color: hi.color,
                      }}
                    >
                      🏥 {hi.name}
                    </p>
                  </div>
                  {best ? (
                    <>
                      <p
                        style={{
                          margin: "0 0 4px",
                          fontSize: 16,
                          fontWeight: 800,
                          color: "#1e293b",
                        }}
                      >
                        🥇 {best.menu}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span
                          style={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: hi.color,
                          }}
                        >
                          👍 {best.likes}
                        </span>
                        {best.cafeteria && (
                          <span style={{ fontSize: 11, color: "#94a3b8" }}>
                            {best.cafeteria}
                          </span>
                        )}
                      </div>
                    </>
                  ) : (
                    <p
                      style={{
                        margin: 0,
                        fontSize: 13,
                        color: "#94a3b8",
                        fontStyle: "italic",
                      }}
                    >
                      아직 베스트 메뉴가 없어요
                    </p>
                  )}
                </div>
              );
            })}
          </>
        )}

        <button
          onClick={onClose}
          style={{
            width: "100%",
            padding: "12px 0",
            borderRadius: 12,
            border: "none",
            background: "linear-gradient(135deg,#6366f1,#4f46e5)",
            color: "#fff",
            fontWeight: 700,
            fontSize: 14,
            cursor: "pointer",
            fontFamily: "inherit",
            marginTop: 8,
          }}
        >
          닫기
        </button>
      </div>
    </div>
  );
}

function LunchAddModal({ hospital, uuid, nick, cafeterias, onClose, onDone }) {
  const h = H[hospital] || H.amc;
  const [cafeteria, setCafeteria] = useState("");
  const [customCafe, setCustomCafe] = useState("");
  const [showCustom, setShowCustom] = useState(cafeterias.length === 0);
  const [menu, setMenu] = useState("");
  const [loading, setLoading] = useState(false);

  const finalCafeteria = showCustom ? customCafe : cafeteria;
  const canSubmit = menu.trim().length > 0 && !loading;

  const submit = async () => {
    if (!canSubmit) return;
    setLoading(true);
    try {
      const result = await saveLunchMenu(
        hospital,
        finalCafeteria,
        menu,
        uuid,
        nick
      );
      onDone(result);
    } catch (e) {
      console.error("메뉴 등록 실패:", e);
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.88)",
        zIndex: 300,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: "20px 20px 0 0",
          padding: "1.5rem 1.5rem 3rem",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 18,
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: 16,
              fontWeight: 800,
              color: "#1e293b",
            }}
          >
            🍱 오늘의 메뉴 공유하기
          </h3>
          <button
            onClick={onClose}
            style={{
              background: "rgba(0,0,0,0.04)",
              border: "none",
              borderRadius: 8,
              padding: 7,
              cursor: "pointer",
              fontSize: 16,
            }}
          >
            ✕
          </button>
        </div>

        <p
          style={{
            fontSize: 13,
            color: "#64748b",
            margin: "0 0 20px",
            lineHeight: 1.6,
          }}
        >
          동료들에게 오늘 메뉴를 알려주세요 🙌
        </p>

        <p
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#475569",
            letterSpacing: ".1em",
            marginBottom: 7,
          }}
        >
          식당
        </p>
        {!showCustom && cafeterias.length > 0 ? (
          <>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 6,
                marginBottom: 10,
              }}
            >
              {cafeterias.map((c) => (
                <button
                  key={c}
                  onClick={() => setCafeteria(c)}
                  style={{
                    padding: "8px 14px",
                    borderRadius: 10,
                    border: `0.5px solid ${
                      cafeteria === c ? h.color + "60" : "rgba(0,0,0,0.1)"
                    }`,
                    background:
                      cafeteria === c ? `${h.color}14` : "rgba(0,0,0,0.03)",
                    color: cafeteria === c ? h.color : "#475569",
                    fontSize: 12,
                    fontWeight: cafeteria === c ? 700 : 600,
                    cursor: "pointer",
                    fontFamily: "inherit",
                  }}
                >
                  {c}
                </button>
              ))}
              <button
                onClick={() => setShowCustom(true)}
                style={{
                  padding: "8px 14px",
                  borderRadius: 10,
                  border: `0.5px dashed ${h.color}50`,
                  background: "none",
                  color: h.color,
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                + 다른 식당
              </button>
            </div>
          </>
        ) : (
          <>
            <input
              value={customCafe}
              onChange={(e) => setCustomCafe(e.target.value)}
              placeholder="예) 본관 직원식당"
              maxLength={20}
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "11px 13px",
                background: "rgba(0,0,0,0.03)",
                border: "0.5px solid rgba(0,0,0,0.08)",
                borderRadius: 11,
                color: "#1e293b",
                fontSize: 13,
                fontFamily: "inherit",
                outline: "none",
                marginBottom: 6,
              }}
            />
            {cafeterias.length > 0 && (
              <button
                onClick={() => {
                  setShowCustom(false);
                  setCustomCafe("");
                }}
                style={{
                  fontSize: 11,
                  color: "#94a3b8",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  padding: 0,
                  textDecoration: "underline",
                  marginBottom: 10,
                }}
              >
                ← 기존 식당에서 선택
              </button>
            )}
          </>
        )}

        <p
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#475569",
            letterSpacing: ".1em",
            marginBottom: 7,
            marginTop: 16,
          }}
        >
          오늘 메뉴 <span style={{ color: "#f43f5e" }}>*</span>
        </p>
        <textarea
          value={menu}
          onChange={(e) => setMenu(e.target.value)}
          placeholder="예) A코너: 갈비탕, B코너: 돈까스"
          rows={3}
          maxLength={100}
          style={{
            width: "100%",
            boxSizing: "border-box",
            background: "rgba(0,0,0,0.03)",
            border: "0.5px solid rgba(0,0,0,0.08)",
            borderRadius: 11,
            padding: "11px 13px",
            color: "#1e293b",
            fontSize: 13,
            fontFamily: "inherit",
            resize: "none",
            outline: "none",
            marginBottom: 6,
          }}
        />
        <p
          style={{
            fontSize: 10,
            color: "#94a3b8",
            margin: "0 0 16px",
            textAlign: "right",
          }}
        >
          {menu.length} / 100
        </p>

        <button
          disabled={!canSubmit}
          onClick={submit}
          style={{
            width: "100%",
            padding: "14px 0",
            borderRadius: 13,
            border: "none",
            fontWeight: 700,
            fontSize: 14,
            fontFamily: "inherit",
            background: canSubmit
              ? `linear-gradient(135deg,${h.color},#6366f1)`
              : "rgba(99,102,241,0.15)",
            color: canSubmit ? "#fff" : "#475569",
            cursor: canSubmit ? "pointer" : "not-allowed",
          }}
        >
          {loading ? "등록 중..." : "메뉴 공유하기 🙌"}
        </button>
      </div>
    </div>
  );
}

function Dashboard({ hospital, nick, uuid, onLogout, onThankYou }) {
  const h = H[hospital];
  const [tab, setTab] = useState("search");
  const [hf, setHf] = useState(hospital);
  const [q, setQ] = useState("");
  const [modal, setModal] = useState(null);
  const [done, setDone] = useState(new Set());
  const [doneData, setDoneData] = useState({});
  const [recTotals, setRecTotals] = useState({});
  const [published, setPublished] = useState(false);

  const [participantNum, setParticipantNum] = useState(0);
  const [showContact, setShowContact] = useState(false);
  const [showDoctorChange, setShowDoctorChange] = useState(false);

  const period = getCurrentPeriod();

  useEffect(() => {
    if (!uuid || uuid === "anonymous") return;
    const load = async () => {
      try {
        const { db } = await import("./firebase.js");
        const { collection, query, where, getDocs } = await import(
          "firebase/firestore"
        );
        const q2 = query(
          collection(db, "recommendations"),
          where("uuid", "==", uuid)
        );
        const snap = await getDocs(q2);
        const ids = new Set();
        const data = {};
        snap.docs.forEach((d) => {
          const rec = d.data();
          if (rec.thumbs === 0) return;
          ids.add(rec.docId);
          data[rec.docId] = {
            thumbs: rec.thumbs || 1,
            hasChanged: !!rec[period.key],
          };
        });
        setDone(ids);
        setDoneData(data);
        const { collection: col3, getDocs: gd3 } = await import(
          "firebase/firestore"
        );
        const allRecSnap = await gd3(col3(db, "recommendations"));
        const totals = {};
        allRecSnap.docs.forEach((d) => {
          const rec = d.data();
          if (rec.thumbs > 0) {
            if (!totals[rec.docId]) totals[rec.docId] = 0;
            totals[rec.docId] += rec.thumbs;
          }
        });
        setRecTotals(totals);
        try {
          const { doc: docRef2, getDoc: gd4 } = await import(
            "firebase/firestore"
          );
          const settingSnap = await gd4(docRef2(db, "settings", "ranking"));
          if (settingSnap.exists())
            setPublished(settingSnap.data().published || false);
        } catch (e) {}
        try {
          const { collection: col2, getDocs: gd2 } = await import(
            "firebase/firestore"
          );
          const userSnap = await gd2(col2(db, "users"));
          const myIdx = userSnap.docs.findIndex((d) => d.data().uuid === uuid);
          setParticipantNum(myIdx >= 0 ? myIdx + 1 : userSnap.size);
        } catch (e) {}
      } catch (e) {
        console.error("추천 목록 로드 실패:", e);
      }
    };
    load();
  }, [uuid]);

  const filtered = useMemo(
    () =>
      ALL_DOCS.filter((d) => {
        if (hf !== "all" && d.hid !== hf) return false;
        if (!q.trim()) return true;
        const qn = q.trim();
        return (
          d.n.includes(qn) ||
          d.de.includes(qn) ||
          (d.s || []).some((s) => s.includes(qn))
        );
      }),
    [q, hf]
  );

  const ranked = useMemo(
    () =>
      [...ALL_DOCS]
        .filter((d) => hf === "all" || d.hid === hf)
        .sort((a, b) => (recTotals[b.i] || 0) - (recTotals[a.i] || 0)),
    [hf, recTotals]
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        color: "#1e293b",
        fontFamily:
          "'Pretendard','Apple SD Gothic Neo',-apple-system,sans-serif",
        maxWidth: 420,
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          padding: "2rem 1.5rem 1rem",
          borderBottom: "0.5px solid rgba(0,0,0,0.06)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: 10,
              background: `${h.color}18`,
              border: `0.5px solid ${h.color}30`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Cross size={14} color={h.color} />
          </div>
          <div>
            <p
              style={{
                margin: 0,
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: ".2em",
                color: h.color,
              }}
            >
              PEER:AGE
            </p>
            <p
              style={{
                margin: 0,
                fontSize: 13,
                fontWeight: 700,
                color: "#94a3b8",
              }}
            >
              {h.short}
            </p>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ textAlign: "right" }}>
            <span
              style={{
                padding: "4px 11px",
                borderRadius: 20,
                background: `${h.color}14`,
                border: `0.5px solid ${h.color}28`,
                fontSize: 11,
                fontWeight: 700,
                color: h.color,
              }}
            >
              {participantNum > 0 ? `${participantNum}번째 참가자` : nick}
            </span>
          </div>
          <button
            onClick={() => setShowContact(true)}
            style={{
              background: "none",
              border: "none",
              color: "#94a3b8",
              fontSize: 11,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            문의
          </button>
          <button
            onClick={() => setShowDoctorChange(true)}
            style={{
              background: "none",
              border: "none",
              color: "#94a3b8",
              fontSize: 11,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            정보공유
          </button>
          <button
            onClick={onLogout}
            style={{
              background: "none",
              border: "none",
              color: "#94a3b8",
              fontSize: 11,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            로그아웃
          </button>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          borderBottom: "0.5px solid rgba(0,0,0,0.06)",
          padding: "0 1.5rem",
        }}
      >
        {[
          { id: "search", l: "추천하기" },
          { id: "ranking", l: "추천 순위" },
          { id: "lunch", l: "🍱 오늘의 메뉴" },
        ].map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              flex: 1,
              padding: "13px 0",
              background: "none",
              border: "none",
              borderBottom:
                tab === t.id ? `2px solid ${h.color}` : "2px solid transparent",
              color: tab === t.id ? h.color : "#475569",
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "inherit",
              marginBottom: -1,
            }}
          >
            {t.l}
          </button>
        ))}
      </div>

      <div style={{ flex: 1, overflowY: "auto", padding: "1.25rem 1.5rem" }}>
        {tab === "search" && (
          <>
            <SearchInput
              value={q}
              onChange={setQ}
              onClear={() => setQ("")}
              onSearch={(v) => {
                window._lastSearch = v;
                const isDocName = ALL_DOCS.some((d) => d.n === v);
                const isDiseaseSpec = ALL_DOCS.some((d) =>
                  (d.s || []).some((s) => s.includes(v))
                );
                if (isDocName || isDiseaseSpec)
                  window._logSearch &&
                    window._logSearch(v, isDocName ? "name" : "disease");
              }}
            />
            <p style={{ fontSize: 11, color: "#475569", marginBottom: 12 }}>
              <span style={{ color: "#60a5fa", fontWeight: 700 }}>
                {filtered.length.toLocaleString()}명
              </span>
              {q && <span> · "{q}" 검색 결과</span>}
            </p>
            <div
              style={{
                background: `linear-gradient(135deg,${h.color}15,rgba(96,165,250,0.1))`,
                border: `0.5px solid ${h.color}30`,
                borderRadius: 14,
                padding: "14px 16px",
                marginBottom: 14,
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <ThumbIcon filled size={18} color={h.color} />
              <p
                style={{
                  margin: 0,
                  fontSize: 14,
                  fontWeight: 700,
                  color: h.color,
                  letterSpacing: "-0.3px",
                }}
              >
                임상 현장 동료들의 추천
              </p>
            </div>
            {filtered.slice(0, 50).map((doc) => {
              const dh = H[doc.hid] || h;
              const isDone = done.has(doc.i);
              const docData = doneData[doc.i];
              return (
                <div
                  key={doc.i}
                  style={{
                    background: "rgba(0,0,0,0.03)",
                    border: "0.5px solid rgba(0,0,0,0.07)",
                    borderRadius: 16,
                    padding: 14,
                    marginBottom: 10,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <Avatar
                        photo={""}
                        color={dh.color}
                        hid={doc.hid}
                        size={44}
                      />
                      <div>
                        <p
                          style={{
                            margin: 0,
                            fontSize: 15,
                            fontWeight: 700,
                            color: "#1e293b",
                          }}
                        >
                          {doc.n}
                        </p>
                        <p
                          style={{
                            margin: "2px 0 5px",
                            fontSize: 11,
                            color: "#64748b",
                          }}
                        >
                          {doc.de}
                        </p>
                        <HBadge hid={doc.hid} />
                      </div>
                    </div>
                    <div style={{ textAlign: "right", flexShrink: 0 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 3,
                          justifyContent: "flex-end",
                          fontSize: 17,
                          fontWeight: 700,
                          color: "#1e293b",
                        }}
                      >
                        <ThumbIcon
                          filled={(recTotals[doc.i] || 0) > 0}
                          size={12}
                          color="#60a5fa"
                        />{" "}
                        {recTotals[doc.i] || 0}
                      </div>
                    </div>
                  </div>
                  {(doc.s || []).length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 4,
                        marginBottom: 10,
                      }}
                    >
                      {(doc.s || []).slice(0, 3).map((s) => (
                        <span
                          key={s}
                          style={{
                            fontSize: 10,
                            padding: "2px 7px",
                            borderRadius: 8,
                            background: `${dh.color}12`,
                            color: dh.color,
                            border: `0.5px solid ${dh.color}25`,
                          }}
                        >
                          {s}
                        </span>
                      ))}
                    </div>
                  )}
                  <RecBars recs={doc.recs} />

                  {isDone && docData ? (
                    <div style={{ marginTop: 10 }}>
                      {docData.thumbs > 0 && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                            marginBottom: 8,
                          }}
                        >
                          <span style={{ fontSize: 11, color: "#64748b" }}>
                            내 추천:
                          </span>
                          <div style={{ display: "flex", gap: 3 }}>
                            {[1, 2, 3, 4, 5].map((i) => (
                              <svg
                                key={i}
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill={i <= docData.thumbs ? dh.color : "none"}
                                stroke={
                                  i <= docData.thumbs
                                    ? dh.color
                                    : "rgba(0,0,0,0.15)"
                                }
                                strokeWidth="1.8"
                              >
                                <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z" />
                                <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
                              </svg>
                            ))}
                          </div>
                        </div>
                      )}
                      <button
                        onClick={() => setModal(doc)}
                        style={{
                          width: "100%",
                          padding: "10px 0",
                          borderRadius: 10,
                          fontSize: 13,
                          fontWeight: 700,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                          fontFamily: "inherit",
                          border: `0.5px solid ${dh.color}30`,
                          background: `${dh.color}0a`,
                          color: dh.color,
                        }}
                      >
                        <ThumbIcon filled size={13} color={dh.color} />
                        {docData.thumbs === 0
                          ? "다시 추천하기"
                          : docData.hasChanged
                          ? "변경 완료"
                          : "변경하기"}
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => setModal(doc)}
                      style={{
                        width: "100%",
                        padding: "10px 0",
                        borderRadius: 10,
                        fontSize: 13,
                        fontWeight: 700,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                        fontFamily: "inherit",
                        marginTop: 10,
                        border: `0.5px solid ${dh.color}30`,
                        background: `${dh.color}14`,
                        color: dh.color,
                      }}
                    >
                      <ThumbIcon size={13} color={dh.color} />이 의사를
                      추천합니다
                    </button>
                  )}
                </div>
              );
            })}
            {filtered.length > 50 && (
              <p
                style={{
                  textAlign: "center",
                  color: "#94a3b8",
                  fontSize: 12,
                  padding: "12px 0",
                }}
              >
                검색어를 더 입력하면 좁혀집니다 (
                {filtered.length.toLocaleString()}명 중 50명 표시)
              </p>
            )}
            {filtered.length === 0 && (
              <div style={{ textAlign: "center", padding: "30px 0" }}>
                <p style={{ color: "#475569", fontSize: 14, marginBottom: 20 }}>
                  검색 결과가 없습니다
                </p>
                <div
                  style={{
                    background: `linear-gradient(135deg,${h.color}10,rgba(96,165,250,0.08))`,
                    border: `0.5px solid ${h.color}30`,
                    borderRadius: 14,
                    padding: "20px 18px",
                    marginTop: 10,
                  }}
                >
                  <p
                    style={{
                      margin: "0 0 6px",
                      fontSize: 14,
                      fontWeight: 700,
                      color: "#1e293b",
                    }}
                  >
                    찾으시는 동료가 없나요?
                  </p>
                  <p
                    style={{
                      margin: "0 0 16px",
                      fontSize: 12,
                      color: "#64748b",
                      lineHeight: 1.6,
                    }}
                  >
                    새 동료가 오시거나 정보가 바뀐 경우
                    <br />
                    알려주세요 🙏
                  </p>
                  <button
                    onClick={() => setShowDoctorChange(true)}
                    style={{
                      width: "100%",
                      padding: "12px 0",
                      borderRadius: 12,
                      border: "none",
                      background: `linear-gradient(135deg,${h.color},#6366f1)`,
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 13,
                      cursor: "pointer",
                      fontFamily: "inherit",
                    }}
                  >
                    🤝 동료 정보 공유
                  </button>
                </div>
              </div>
            )}
          </>
        )}

        {tab === "lunch" && (
          <LunchScreen hospital={hospital} uuid={uuid} nick={nick} />
        )}

        {tab === "ranking" && (
          <>
            {!published ? (
              <div style={{ textAlign: "center", padding: "40px 20px" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
                <p
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#1e293b",
                    margin: "0 0 8px",
                  }}
                >
                  순위 집계 중입니다
                </p>
                <p style={{ fontSize: 13, color: "#64748b" }}>
                  {period.label} 결과는 추후 공개됩니다
                </p>
              </div>
            ) : (
              <>
                <div
                  style={{
                    background: "rgba(99,102,241,0.08)",
                    border: "0.5px solid rgba(99,102,241,0.2)",
                    borderRadius: 11,
                    padding: "10px 13px",
                    marginBottom: 14,
                    display: "flex",
                    gap: 8,
                  }}
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#6366f1"
                    strokeWidth="2"
                    style={{ flexShrink: 0, marginTop: 1 }}
                  >
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                  </svg>
                  <div>
                    <p
                      style={{
                        margin: "0 0 2px",
                        fontSize: 12,
                        fontWeight: 700,
                        color: "#a5b4fc",
                      }}
                    >
                      🎉 순위가 공개되었습니다!
                    </p>
                    <p style={{ margin: 0, fontSize: 11, color: "#475569" }}>
                      가입자만 전체 순위 열람 가능
                    </p>
                  </div>
                </div>
                {ranked.slice(0, 30).map((doc, i) => {
                  const dh = H[doc.hid] || h;
                  const t = totalRec(doc.recs);
                  return (
                    <div
                      key={doc.i}
                      style={{
                        background: "rgba(0,0,0,0.03)",
                        border: `0.5px solid ${
                          i === 0 ? dh.color + "45" : "rgba(0,0,0,0.07)"
                        }`,
                        borderRadius: 16,
                        padding: 14,
                        marginBottom: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          marginBottom: 10,
                        }}
                      >
                        <span
                          style={{
                            fontSize: i === 0 ? 16 : 12,
                            color: i === 0 ? "#fbbf24" : "#94a3b8",
                            fontWeight: 700,
                            width: 20,
                            textAlign: "center",
                            flexShrink: 0,
                          }}
                        >
                          {i === 0 ? "★" : i + 1}
                        </span>
                        <Avatar
                          photo={""}
                          color={dh.color}
                          hid={doc.hid}
                          size={38}
                        />
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <p
                            style={{
                              margin: "0 0 3px",
                              fontSize: 14,
                              fontWeight: 700,
                              color: "#1e293b",
                            }}
                          >
                            {doc.n}
                          </p>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              flexWrap: "wrap",
                            }}
                          >
                            <p
                              style={{
                                margin: 0,
                                fontSize: 11,
                                color: "#64748b",
                              }}
                            >
                              {doc.de}
                            </p>
                            <HBadge hid={doc.hid} />
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 3,
                            fontSize: 17,
                            fontWeight: 700,
                            color: "#1e293b",
                            flexShrink: 0,
                          }}
                        >
                          <ThumbIcon filled size={12} color="#60a5fa" /> {t}
                        </div>
                      </div>
                      <RecBars recs={doc.recs} />
                    </div>
                  );
                })}
              </>
            )}
          </>
        )}
      </div>

      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          pointerEvents: "none",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "8px",
          userSelect: "none",
        }}
      >
        <span
          style={{
            fontSize: 10,
            color: "rgba(0,0,0,0.08)",
            fontWeight: 700,
            letterSpacing: ".1em",
          }}
        >
          {participantNum > 0 ? `${participantNum}번째 참가자` : nick} ·{" "}
          {H[hospital]?.short}
        </span>
      </div>

      {showContact && (
        <ContactScreen
          uuid={uuid}
          nick={nick}
          hospital={hospital}
          onClose={() => setShowContact(false)}
        />
      )}
      {showDoctorChange && (
        <DoctorChangeModal
          uuid={uuid}
          nick={nick}
          hospital={hospital}
          onClose={() => setShowDoctorChange(false)}
        />
      )}
      {modal && (
        <RecModal
          doc={modal}
          nick={nick}
          uuid={uuid}
          isAlreadyDone={done.has(modal.i)}
          prevThumbs={doneData[modal.i]?.thumbs || 0}
          hasChanged={doneData[modal.i]?.hasChanged || false}
          onClose={() => setModal(null)}
          onDone={(newThumbs, wasChange) => {
            if (newThumbs === 0) {
              setDone((p) => {
                const n = new Set(p);
                n.delete(modal.i);
                return n;
              });
              setDoneData((p) => {
                const n = { ...p };
                delete n[modal.i];
                return n;
              });
            } else {
              setDone((p) => new Set([...p, modal.i]));
              setDoneData((p) => ({
                ...p,
                [modal.i]: {
                  thumbs: newThumbs,
                  hasChanged: wasChange || false,
                },
              }));
            }
          }}
          onThankYou={() => {
            setModal(null);
            onThankYou && onThankYou();
          }}
        />
      )}
    </div>
  );
}

function WaitlistScreen({ hospitalName, onBack }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async () => {
    setLoading(true);
    try {
      await registerWaitlist(hospitalName, email || "anonymous");
    } catch (e) {
      console.error(e);
    }
    setSent(true);
    setLoading(false);
  };
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        color: "#1e293b",
        fontFamily:
          "'Pretendard','Apple SD Gothic Neo',-apple-system,sans-serif",
        maxWidth: 420,
        margin: "0 auto",
        padding: "3rem 1.5rem 2rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <button
        onClick={onBack}
        style={{
          background: "none",
          border: "none",
          color: "#64748b",
          fontSize: 12,
          cursor: "pointer",
          textAlign: "left",
          marginBottom: 24,
          padding: 0,
        }}
      >
        ← 돌아가기
      </button>
      <div
        style={{
          width: 46,
          height: 46,
          borderRadius: 15,
          background: "rgba(99,102,241,0.12)",
          border: "0.5px solid rgba(99,102,241,0.25)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "1.5rem",
        }}
      >
        <Cross size={22} />
      </div>
      <p
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: ".22em",
          color: "#6366f1",
          margin: "0 0 14px",
        }}
      >
        PEER:AGE
      </p>
      {sent ? (
        <>
          <h2 style={{ fontSize: 24, fontWeight: 800, margin: "0 0 12px" }}>
            신청 완료! 🎉
          </h2>
          <p
            style={{
              color: "#64748b",
              fontSize: 14,
              lineHeight: 1.7,
              margin: "0 0 20px",
            }}
          >
            <strong style={{ color: "#1e293b" }}>{hospitalName}</strong> 서비스
            신청이 접수되었습니다.
            <br />
            요청이 많을수록 빨리 추가됩니다!
          </p>
          <div
            style={{
              background: "rgba(99,102,241,0.08)",
              border: "0.5px solid rgba(99,102,241,0.2)",
              borderRadius: 14,
              padding: 16,
              marginTop: "auto",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: 13,
                color: "#818cf8",
                textAlign: "center",
              }}
            >
              좋은 의사를 찾는 선한 영향력에 함께해 주셔서 감사합니다 😊
            </p>
          </div>
        </>
      ) : (
        <>
          <h2 style={{ fontSize: 24, fontWeight: 800, margin: "0 0 8px" }}>
            {hospitalName}
          </h2>
          <div
            style={{
              background: "rgba(251,191,36,0.08)",
              border: "0.5px solid rgba(251,191,36,0.3)",
              borderRadius: 14,
              padding: 16,
              marginBottom: 20,
            }}
          >
            <p
              style={{
                margin: "0 0 4px",
                fontSize: 14,
                fontWeight: 700,
                color: "#d97706",
              }}
            >
              아직 서비스가 등록되지 않은 병원입니다
            </p>
            <p style={{ margin: 0, fontSize: 13, color: "#64748b" }}>
              서비스를 신청하시겠습니까?
            </p>
          </div>
          <button
            disabled={loading}
            onClick={submit}
            style={{
              width: "100%",
              padding: "15px 0",
              borderRadius: 14,
              border: "none",
              fontWeight: 700,
              fontSize: 15,
              cursor: "pointer",
              background: "linear-gradient(135deg,#6366f1,#4f46e5)",
              color: "#fff",
              fontFamily: "inherit",
              marginBottom: 16,
            }}
          >
            {loading ? "신청 중..." : "서비스 신청하기"}
          </button>
          <p style={{ fontSize: 12, color: "#94a3b8", margin: "0 0 8px" }}>
            이메일을 남기시면 서비스 오픈 시 알려드립니다 (선택사항)
          </p>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            placeholder="이메일 주소"
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "14px 18px",
              background: "rgba(0,0,0,0.04)",
              border: "0.5px solid rgba(0,0,0,0.1)",
              borderRadius: 13,
              color: "#1e293b",
              fontSize: 14,
              outline: "none",
              fontFamily: "inherit",
            }}
          />
        </>
      )}
    </div>
  );
}

function MainScreen({ onStart, onLogin }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        color: "#1e293b",
        fontFamily:
          "'Pretendard','Apple SD Gothic Neo',-apple-system,sans-serif",
        maxWidth: 420,
        margin: "0 auto",
        padding: "3rem 1.5rem 2rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: 46,
          height: 46,
          borderRadius: 15,
          background: "rgba(99,102,241,0.12)",
          border: "0.5px solid rgba(99,102,241,0.25)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "2.5rem",
        }}
      >
        <Cross size={22} />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          margin: "0 0 10px",
        }}
      >
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: ".22em",
            color: "#6366f1",
          }}
        >
          PEER:AGE
        </span>
        <span style={{ fontSize: 11, color: "#94a3b8" }}>·</span>
        <span style={{ fontSize: 11, fontWeight: 600, color: "#64748b" }}>
          동료 시대
        </span>
      </div>
      <h1
        style={{
          fontSize: 22,
          fontWeight: 800,
          letterSpacing: -0.5,
          lineHeight: 1.4,
          margin: "0 0 16px",
          color: "#60a5fa",
        }}
      >
        병원 의료진의 진료 가이드
      </h1>
      <p
        style={{
          color: "#1e293b",
          fontSize: 14,
          fontWeight: 600,
          lineHeight: 1.7,
          margin: "0 0 10px",
        }}
      >
        내 가족을 맡길 수 있는 의사,
        <br />
        동료 의료진이 직접 추천합니다
      </p>
      <p
        style={{
          color: "#64748b",
          fontSize: 12,
          lineHeight: 1.9,
          margin: "0 0 20px",
          fontStyle: "italic",
        }}
      >
        "엄마 진료 어느 분께 보죠?"
        <br />
        "암 진단받았는데 누구 추천해?"
      </p>
      <div
        style={{
          display: "flex",
          gap: 6,
          flexWrap: "wrap",
          marginBottom: "auto",
        }}
      >
        {Object.values(H).map((h) => (
          <span
            key={h.id}
            style={{
              fontSize: 10,
              padding: "3px 9px",
              borderRadius: 20,
              background: `${h.color}14`,
              border: `0.5px solid ${h.color}30`,
              color: h.color,
              fontWeight: 700,
            }}
          >
            {h.short}
          </span>
        ))}
      </div>
      <div
        style={{
          marginTop: 32,
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <button
          onClick={onStart}
          style={{
            width: "100%",
            padding: "16px 0",
            borderRadius: 14,
            border: "none",
            fontWeight: 700,
            fontSize: 16,
            cursor: "pointer",
            background: "linear-gradient(135deg,#6366f1,#4f46e5)",
            color: "#fff",
            fontFamily: "inherit",
          }}
        >
          시작하기
        </button>
        <button
          onClick={onLogin}
          style={{
            width: "100%",
            padding: "14px 0",
            borderRadius: 14,
            border: "0.5px solid rgba(99,102,241,0.3)",
            fontWeight: 700,
            fontSize: 15,
            cursor: "pointer",
            background: "none",
            color: "#6366f1",
            fontFamily: "inherit",
          }}
        >
          이미 가입하셨나요? 로그인
        </button>
        <a
          href="/privacy.html"
          target="_blank"
          style={{
            fontSize: 11,
            color: "#94a3b8",
            textAlign: "center",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          개인정보처리방침
        </a>
      </div>
    </div>
  );
}

function GpsScreen({ onConfirm, onWaitlist }) {
  const [ready, setReady] = useState(false);
  const [pick, setPick] = useState(false);
  const [detecting, setDetecting] = useState(true);
  const [gpsHospital, setGpsHospital] = useState(null);
  const [manualHosp, setManualHosp] = useState("");
  const [detectedHosp, setDetectedHosp] = useState(null);
  const KEYWORDS = [
    { key: "서울아산", hid: "amc" },
    { key: "서울대학교병원", hid: "snuh" },
    { key: "삼성서울", hid: "smc" },
    { key: "세브란스", hid: "yuhs" },
    { key: "서울성모", hid: "cmcseoul" },
  ];
  useEffect(() => {
    setTimeout(() => setReady(true), 1300);
    if (!navigator.geolocation) {
      setDetecting(false);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        fetch(
          `/api/nearby?lat=${pos.coords.latitude}&lng=${pos.coords.longitude}`
        )
          .then((r) => r.json())
          .then((data) => {
            setDetecting(false);
            const places = data.places || [];
            if (places.length > 0) {
              let matched = null;
              for (let i = 0; i < places.length; i++) {
                const name = places[i].displayName?.text || "";
                const found = KEYWORDS.find((b) => name.includes(b.key));
                if (found && H[found.hid]) {
                  matched = found;
                  break;
                }
              }
              setDetectedHosp(
                matched || {
                  hid: "other",
                  name: places[0].displayName?.text || "근처 병원",
                }
              );
            } else {
              setDetecting(false);
            }
          })
          .catch(() => setDetecting(false));
      },
      () => setDetecting(false)
    );
  }, []);
  const detectHospital = () => {
    setDetecting(true);
    if (!navigator.geolocation) {
      setDetecting(false);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        fetch(
          `/api/nearby?lat=${pos.coords.latitude}&lng=${pos.coords.longitude}`
        )
          .then((r) => r.json())
          .then((data) => {
            setDetecting(false);
            const places = data.places || [];
            if (places.length > 0) {
              let matched = null;
              for (let i = 0; i < places.length; i++) {
                const name = places[i].displayName?.text || "";
                const found = KEYWORDS.find((b) => name.includes(b.key));
                if (found && H[found.hid]) {
                  matched = found;
                  break;
                }
              }
              if (matched) onConfirm(matched.hid);
              else setGpsHospital(places[0].displayName?.text || "근처 병원");
            } else {
              setGpsHospital("nearby_none");
            }
          })
          .catch(() => {
            setDetecting(false);
            setGpsHospital("nearby_none");
          });
      },
      () => {
        setDetecting(false);
        alert("위치 접근이 거부되었습니다.");
      }
    );
  };
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        color: "#1e293b",
        fontFamily:
          "'Pretendard','Apple SD Gothic Neo',-apple-system,sans-serif",
        maxWidth: 420,
        margin: "0 auto",
        padding: "3rem 1.5rem 2rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: 46,
          height: 46,
          borderRadius: 15,
          background: "rgba(99,102,241,0.12)",
          border: "0.5px solid rgba(99,102,241,0.25)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "2.5rem",
        }}
      >
        <Cross size={22} />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          margin: "0 0 10px",
        }}
      >
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: ".22em",
            color: "#6366f1",
          }}
        >
          PEER:AGE
        </span>
        <span style={{ fontSize: 11, color: "#94a3b8" }}>·</span>
        <span style={{ fontSize: 11, fontWeight: 600, color: "#64748b" }}>
          동료 시대
        </span>
      </div>
      <h1
        style={{
          fontSize: 22,
          fontWeight: 800,
          letterSpacing: -0.5,
          lineHeight: 1.4,
          margin: "0 0 16px",
          color: "#60a5fa",
        }}
      >
        병원 의료진의 진료 가이드
      </h1>
      <p
        style={{
          color: "#1e293b",
          fontSize: 14,
          fontWeight: 600,
          lineHeight: 1.7,
          margin: "0 0 10px",
        }}
      >
        내 가족을 맡길 수 있는 의사,
        <br />
        동료 의료진이 직접 추천합니다
      </p>
      <p
        style={{
          color: "#64748b",
          fontSize: 12,
          lineHeight: 1.9,
          margin: "0 0 20px",
          fontStyle: "italic",
        }}
      >
        "엄마 진료 어느 분께 보죠?"
        <br />
        "암 진단받았는데 누구 추천해?"
      </p>
      <div
        style={{
          display: "flex",
          gap: 6,
          flexWrap: "wrap",
          marginBottom: "auto",
        }}
      >
        {Object.values(H).map((h) => (
          <span
            key={h.id}
            style={{
              fontSize: 10,
              padding: "3px 9px",
              borderRadius: 20,
              background: `${h.color}14`,
              border: `0.5px solid ${h.color}30`,
              color: h.color,
              fontWeight: 700,
            }}
          >
            {h.short}
          </span>
        ))}
      </div>
      {!ready ? (
        <div
          style={{
            background: "rgba(99,102,241,0.08)",
            border: "0.5px solid rgba(99,102,241,0.2)",
            borderRadius: 14,
            padding: 14,
            marginTop: 28,
            display: "flex",
            alignItems: "center",
            gap: 10,
            justifyContent: "center",
          }}
        >
          <p style={{ margin: 0, fontSize: 13, color: "#818cf8" }}>
            📍 위치 확인 중...
          </p>
        </div>
      ) : (
        <div
          style={{
            background: detectedHosp
              ? `${(H[detectedHosp.hid] || { color: "#6366f1" }).color}0e`
              : "rgba(99,102,241,0.06)",
            border: `0.5px solid ${
              detectedHosp
                ? (H[detectedHosp.hid] || { color: "#6366f1" }).color + "30"
                : "rgba(99,102,241,0.2)"
            }`,
            borderRadius: 16,
            padding: 16,
            marginTop: 28,
          }}
        >
          {detecting ? (
            <p style={{ margin: "0 0 14px", fontSize: 14, color: "#64748b" }}>
              📍 근처 병원 확인 중...
            </p>
          ) : detectedHosp && detectedHosp.hid !== "other" ? (
            <>
              <p
                style={{
                  margin: "0 0 4px",
                  fontSize: 19,
                  fontWeight: 800,
                  color: "#1e293b",
                }}
              >
                {H[detectedHosp.hid].name}에
              </p>
              <p style={{ margin: "0 0 14px", fontSize: 15, color: "#64748b" }}>
                근무 중이신가요?
              </p>
            </>
          ) : detectedHosp && detectedHosp.hid === "other" ? (
            <>
              <p
                style={{
                  margin: "0 0 4px",
                  fontSize: 19,
                  fontWeight: 800,
                  color: "#1e293b",
                }}
              >
                {detectedHosp.name}에
              </p>
              <p style={{ margin: "0 0 14px", fontSize: 15, color: "#64748b" }}>
                근무 중이신가요?
              </p>
            </>
          ) : (
            <p style={{ margin: "0 0 14px", fontSize: 14, color: "#64748b" }}>
              📍 병원 위치가 확인되지 않습니다
            </p>
          )}
          {detectedHosp && (
            <div style={{ display: "flex", gap: 10 }}>
              <button
                onClick={() =>
                  detectedHosp.hid !== "other"
                    ? onConfirm(detectedHosp.hid)
                    : onWaitlist(detectedHosp.name)
                }
                style={{
                  flex: 1,
                  padding: "12px 0",
                  borderRadius: 12,
                  background: `linear-gradient(135deg,${
                    H[detectedHosp.hid] ? H[detectedHosp.hid].color : "#6366f1"
                  },#4f46e5)`,
                  border: "none",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: 14,
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                네, 맞습니다
              </button>
              <button
                onClick={() => setPick((v) => !v)}
                style={{
                  flex: 1,
                  padding: "12px 0",
                  borderRadius: 12,
                  background: "rgba(0,0,0,0.04)",
                  border: "0.5px solid rgba(0,0,0,0.1)",
                  color: "#64748b",
                  fontWeight: 700,
                  fontSize: 14,
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                다른 병원
              </button>
            </div>
          )}
          {!detectedHosp && !detecting && (
            <button
              onClick={() => setPick(true)}
              style={{
                width: "100%",
                padding: "12px 0",
                borderRadius: 12,
                background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                border: "none",
                color: "#fff",
                fontWeight: 700,
                fontSize: 14,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              병원 선택하기
            </button>
          )}
          {pick && (
            <div
              style={{
                marginTop: 10,
                background: "#fff",
                borderRadius: 12,
                border: "0.5px solid rgba(0,0,0,0.08)",
                overflow: "hidden",
              }}
            >
              {Object.values(H).map((hh) => (
                <button
                  key={hh.id}
                  onClick={() => onConfirm(hh.id)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    width: "100%",
                    padding: "12px 14px",
                    background: "none",
                    border: "none",
                    borderBottom: "0.5px solid rgba(0,0,0,0.06)",
                    cursor: "pointer",
                    fontFamily: "inherit",
                    textAlign: "left",
                  }}
                >
                  <span
                    style={{
                      width: 7,
                      height: 7,
                      borderRadius: "50%",
                      background: hh.color,
                      flexShrink: 0,
                    }}
                  />
                  <span
                    style={{ fontSize: 13, color: "#1e293b", fontWeight: 600 }}
                  >
                    {hh.name}
                  </span>
                </button>
              ))}
              {!gpsHospital ? (
                <button
                  onClick={detectHospital}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    width: "100%",
                    padding: "12px 14px",
                    background: "rgba(99,102,241,0.05)",
                    border: "none",
                    cursor: "pointer",
                    fontFamily: "inherit",
                    textAlign: "left",
                  }}
                >
                  <span style={{ fontSize: 13 }}>📍</span>
                  <span
                    style={{ fontSize: 13, color: "#6366f1", fontWeight: 700 }}
                  >
                    {detecting ? "위치 확인 중..." : "우리 병원이 없어요"}
                  </span>
                </button>
              ) : gpsHospital === "nearby_none" ? (
                <div
                  style={{
                    padding: "12px 14px",
                    background: "rgba(99,102,241,0.06)",
                    borderTop: "0.5px solid rgba(99,102,241,0.15)",
                  }}
                >
                  <p
                    style={{
                      margin: "0 0 8px",
                      fontSize: 12,
                      color: "#64748b",
                    }}
                  >
                    근처 병원을 찾을 수 없습니다. 병원명을 직접 입력해 주세요.
                  </p>
                  <input
                    autoFocus
                    placeholder="예) 고려대학교병원"
                    value={manualHosp}
                    onChange={(e) => setManualHosp(e.target.value)}
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      padding: "10px 12px",
                      background: "#fff",
                      border: "0.5px solid rgba(99,102,241,0.3)",
                      borderRadius: 10,
                      fontSize: 13,
                      outline: "none",
                      fontFamily: "inherit",
                      marginBottom: 8,
                      color: "#1e293b",
                    }}
                  />
                  <div style={{ display: "flex", gap: 8 }}>
                    <button
                      disabled={!manualHosp.trim()}
                      onClick={() => {
                        if (manualHosp.trim()) onWaitlist(manualHosp.trim());
                      }}
                      style={{
                        flex: 1,
                        padding: "10px 0",
                        borderRadius: 10,
                        border: "none",
                        background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: 13,
                        cursor: "pointer",
                        fontFamily: "inherit",
                      }}
                    >
                      추가 요청하기
                    </button>
                    <button
                      onClick={() => setGpsHospital(null)}
                      style={{
                        flex: 1,
                        padding: "10px 0",
                        borderRadius: 10,
                        border: "0.5px solid rgba(0,0,0,0.1)",
                        background: "none",
                        color: "#64748b",
                        fontWeight: 700,
                        fontSize: 13,
                        cursor: "pointer",
                        fontFamily: "inherit",
                      }}
                    >
                      다시 시도
                    </button>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    padding: "12px 14px",
                    background: "rgba(99,102,241,0.08)",
                    borderTop: "0.5px solid rgba(99,102,241,0.15)",
                  }}
                >
                  <p
                    style={{
                      margin: "0 0 4px",
                      fontSize: 12,
                      color: "#6366f1",
                      fontWeight: 700,
                    }}
                  >
                    📍 GPS 감지된 병원
                  </p>
                  <p
                    style={{
                      margin: "0 0 10px",
                      fontSize: 15,
                      fontWeight: 800,
                      color: "#1e293b",
                    }}
                  >
                    {gpsHospital}에 근무 중이신가요?
                  </p>
                  <div style={{ display: "flex", gap: 8 }}>
                    <button
                      onClick={() => onWaitlist(gpsHospital)}
                      style={{
                        flex: 1,
                        padding: "10px 0",
                        borderRadius: 10,
                        border: "none",
                        background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: 13,
                        cursor: "pointer",
                        fontFamily: "inherit",
                      }}
                    >
                      네, 추가 요청하기
                    </button>
                    <button
                      onClick={() => setGpsHospital(null)}
                      style={{
                        flex: 1,
                        padding: "10px 0",
                        borderRadius: 10,
                        border: "0.5px solid rgba(0,0,0,0.1)",
                        background: "none",
                        color: "#64748b",
                        fontWeight: 700,
                        fontSize: 13,
                        cursor: "pointer",
                        fontFamily: "inherit",
                      }}
                    >
                      다시 시도
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function AuthScreen({ hospital, onDone }) {
  const h = H[hospital];
  const [method, setMethod] = useState("");
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [ok, setOk] = useState(false);
  const [agreed1, setAgreed1] = useState(false);
  const [agreed2, setAgreed2] = useState(false);
  const [agreed3, setAgreed3] = useState(false);
  const allAgreed = agreed1 && agreed2;
  const DOMAINS = [
    "amc.seoul.kr",
    "ulsan.ac.kr",
    "snuh.org",
    "snu.ac.kr",
    "catholic.ac.kr",
    "cmcnu.or.kr",
    "yuhs.ac",
    "yonsei.ac.kr",
    "samsunghospital.com",
    "skku.edu",
  ];
  const emailOk = email.includes("@") && DOMAINS.some((d) => email.endsWith(d));
  const [sentCode, setSentCode] = useState("");
  const CODE = sentCode || "391847";
  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    padding: "14px 18px",
    background: "rgba(0,0,0,0.04)",
    border: "0.5px solid rgba(0,0,0,0.1)",
    borderRadius: 13,
    color: "#1e293b",
    fontSize: 14,
    outline: "none",
    fontFamily: "inherit",
    marginBottom: 10,
  };

  const sendOtp = async () => {
    const code = Math.floor(100000 + Math.random() * 900000).toString();
    setSentCode(code);
    setSent(true);
    try {
      await fetch("/api/send-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, code }),
      });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        color: "#1e293b",
        fontFamily:
          "'Pretendard','Apple SD Gothic Neo',-apple-system,sans-serif",
        maxWidth: 420,
        margin: "0 auto",
        padding: "3rem 1.5rem 2rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <p
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: ".22em",
          color: "#6366f1",
          margin: "0 0 14px",
        }}
      >
        1 / 3 — 소속 인증
      </p>
      <HBadge hid={hospital} />
      <h2 style={{ fontSize: 24, fontWeight: 800, margin: "16px 0 8px" }}>
        직원 인증
      </h2>
      <p style={{ color: "#64748b", fontSize: 14, margin: "0 0 8px" }}>
        실제 소속 직원만 참여할 수 있습니다.
      </p>
      <a
        href="/privacy.html"
        target="_blank"
        style={{
          fontSize: 11,
          color: "#94a3b8",
          textDecoration: "underline",
          cursor: "pointer",
          marginBottom: 16,
          display: "inline-block",
        }}
      >
        개인정보처리방침 보기
      </a>
      {!method && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div
            style={{
              background: "rgba(0,0,0,0.03)",
              border: "0.5px solid rgba(0,0,0,0.08)",
              borderRadius: 12,
              padding: 14,
            }}
          >
            <p
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#475569",
                letterSpacing: ".1em",
                margin: "0 0 10px",
              }}
            >
              약관 동의
            </p>
            {[
              {
                id: 1,
                label: "이용약관 동의",
                checked: agreed1,
                set: setAgreed1,
                link: "/terms.html",
              },
              {
                id: 2,
                label: "개인정보처리방침 동의",
                checked: agreed2,
                set: setAgreed2,
                link: "/privacy.html",
              },
            ].map((item) => (
              <div
                key={item.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 8,
                }}
              >
                <input
                  type="checkbox"
                  checked={item.checked}
                  onChange={(e) => item.set(e.target.checked)}
                  style={{
                    width: 16,
                    height: 16,
                    accentColor: h.color,
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 12, color: "#475569" }}>
                  {item.link ? (
                    <a
                      href={item.link}
                      target="_blank"
                      style={{ color: h.color, textDecoration: "underline" }}
                    >
                      {item.label}
                    </a>
                  ) : (
                    item.label
                  )}{" "}
                  <span style={{ color: "#f43f5e" }}>*</span>
                </span>
              </div>
            ))}
            <button
              onClick={() => {
                setAgreed1(true);
                setAgreed2(true);
                setAgreed3(true);
              }}
              style={{
                fontSize: 11,
                color: h.color,
                background: "none",
                border: "none",
                cursor: "pointer",
                fontFamily: "inherit",
                padding: 0,
                textDecoration: "underline",
              }}
            >
              전체 동의
            </button>
          </div>
          <div
            style={{
              background: "rgba(99,102,241,0.06)",
              border: "0.5px solid rgba(99,102,241,0.15)",
              borderRadius: 11,
              padding: "10px 13px",
              display: "flex",
              gap: 8,
              marginBottom: 4,
            }}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6366f1"
              strokeWidth="2"
              style={{ flexShrink: 0, marginTop: 1 }}
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
            <p style={{ margin: 0, fontSize: 11, color: "#818cf8" }}>
              인증용으로만 확인합니다 · 익명화 처리됩니다
            </p>
          </div>
          <button
            onClick={() => allAgreed && setMethod("email")}
            disabled={!allAgreed}
            style={{
              padding: "18px 20px",
              borderRadius: 14,
              border: `0.5px solid ${h.color}30`,
              background: `${h.color}08`,
              cursor: allAgreed ? "pointer" : "not-allowed",
              fontFamily: "inherit",
              textAlign: "left",
              opacity: allAgreed ? 1 : 0.5,
            }}
          >
            <p
              style={{
                margin: "0 0 4px",
                fontSize: 14,
                fontWeight: 700,
                color: h.color,
              }}
            >
              🏥 기관 이메일 인증
            </p>
            <p style={{ margin: 0, fontSize: 12, color: "#64748b" }}>
              기관 공식 이메일로 인증번호를 받습니다
            </p>
          </button>
        </div>
      )}
      {method === "email" && (
        <>
          <button
            onClick={() => {
              setMethod("");
              setSent(false);
              setOtp("");
              setOk(false);
            }}
            style={{
              background: "none",
              border: "none",
              color: "#64748b",
              fontSize: 12,
              cursor: "pointer",
              textAlign: "left",
              marginBottom: 16,
              padding: 0,
            }}
          >
            ← 인증 방식 변경
          </button>
          <div
            style={{
              background: "rgba(0,0,0,0.03)",
              border: "0.5px solid rgba(0,0,0,0.06)",
              borderRadius: 10,
              padding: "8px 13px",
              marginBottom: 10,
            }}
          >
            <p style={{ margin: 0, fontSize: 11, color: "#475569" }}>
              인증 가능 도메인:{" "}
              <span style={{ color: h.color, fontFamily: "monospace" }}>
                {hospital === "amc"
                  ? "amc.seoul.kr · ulsan.ac.kr"
                  : hospital === "snuh"
                  ? "snuh.org · snu.ac.kr"
                  : hospital === "smc"
                  ? "samsunghospital.com · skku.edu"
                  : hospital === "yuhs"
                  ? "yuhs.ac · yonsei.ac.kr"
                  : "cmcnu.or.kr · catholic.ac.kr"}
              </span>
            </p>
          </div>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            autoFocus
            inputMode="email"
            placeholder={`example@${
              h.id === "amc" ? "amc.seoul.kr" : "hospital.kr"
            }`}
            style={inputStyle}
          />
          {email.includes("@") &&
            (emailOk ? (
              <p style={{ fontSize: 12, color: "#34d399", marginBottom: 10 }}>
                ✓ 소속으로 확인됩니다
              </p>
            ) : (
              <p style={{ fontSize: 12, color: "#f43f5e", marginBottom: 10 }}>
                등록된 도메인이 아닙니다
              </p>
            ))}
          {sent ? (
            <>
              <div
                style={{
                  background: "rgba(96,165,250,0.08)",
                  border: "0.5px solid rgba(96,165,250,0.2)",
                  borderRadius: 11,
                  padding: "9px 13px",
                  marginBottom: 10,
                }}
              >
                <p style={{ margin: 0, fontSize: 12, color: "#93c5fd" }}>
                  {email}로 인증번호를 발송했습니다
                </p>
              </div>
              <input
                value={otp}
                onChange={(e) => {
                  setOtp(e.target.value);
                  setOk(e.target.value === CODE);
                }}
                type="text"
                maxLength={6}
                placeholder="인증번호 6자리"
                style={inputStyle}
              />
              <button
                disabled={!ok}
                onClick={() => onDone(email, "email")}
                style={{
                  width: "100%",
                  padding: "15px 0",
                  borderRadius: 14,
                  border: "none",
                  fontWeight: 700,
                  fontSize: 15,
                  cursor: ok ? "pointer" : "not-allowed",
                  background: ok
                    ? `linear-gradient(135deg,${h.color},#6366f1)`
                    : "rgba(99,102,241,0.15)",
                  color: ok ? "#fff" : "#475569",
                  fontFamily: "inherit",
                }}
              >
                인증 완료
              </button>
            </>
          ) : (
            <button
              disabled={!emailOk}
              onClick={sendOtp}
              style={{
                width: "100%",
                padding: "15px 0",
                borderRadius: 14,
                border: "none",
                fontWeight: 700,
                fontSize: 15,
                cursor: emailOk ? "pointer" : "not-allowed",
                background: emailOk
                  ? `linear-gradient(135deg,${h.color},#6366f1)`
                  : "rgba(99,102,241,0.15)",
                color: emailOk ? "#fff" : "#475569",
                fontFamily: "inherit",
              }}
            >
              인증 메일 발송
            </button>
          )}
        </>
      )}
    </div>
  );
}

function RoleSelect({ hospital, onDone }) {
  const h = H[hospital];
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        color: "#1e293b",
        fontFamily:
          "'Pretendard','Apple SD Gothic Neo',-apple-system,sans-serif",
        maxWidth: 420,
        margin: "0 auto",
        padding: "3rem 1.5rem 2rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <p
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: ".22em",
          color: "#6366f1",
          margin: "0 0 14px",
        }}
      >
        2 / 3 — 직군 선택
      </p>
      <HBadge hid={hospital} />
      <h2 style={{ fontSize: 24, fontWeight: 800, margin: "16px 0 8px" }}>
        직군을 선택하세요
      </h2>
      <p style={{ color: "#64748b", fontSize: 14, margin: "0 0 20px" }}>
        닉네임이 자동으로 부여됩니다.
      </p>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 12,
          marginBottom: 20,
        }}
      >
        {ROLES.map((r) => (
          <button
            key={r.l}
            onClick={() => onDone(r.l, r.n + 1)}
            style={{
              padding: "22px 14px",
              borderRadius: 18,
              background: "rgba(0,0,0,0.03)",
              border: "0.5px solid rgba(0,0,0,0.07)",
              color: "#1e293b",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 10,
              fontFamily: "inherit",
            }}
          >
            <div
              style={{
                width: 42,
                height: 42,
                borderRadius: 13,
                background: `${h.color}18`,
                border: `0.5px solid ${h.color}30`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Cross size={20} color={h.color} />
            </div>
            <span style={{ fontWeight: 700, fontSize: 14 }}>{r.l}</span>
            <span style={{ fontSize: 11, color: "#475569" }}>현재 {r.n}명</span>
          </button>
        ))}
      </div>
    </div>
  );
}

function SetPasswordScreen({ uuid, nick, hospital, onDone }) {
  const h = H[hospital] || H.amc;
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const match = pw.length >= 6 && pw === pw2;
  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    padding: "14px 18px",
    background: "rgba(0,0,0,0.04)",
    border: "0.5px solid rgba(0,0,0,0.1)",
    borderRadius: 13,
    color: "#1e293b",
    fontSize: 14,
    outline: "none",
    fontFamily: "inherit",
    marginBottom: 10,
  };
  const submit = async () => {
    if (!match) return;
    setLoading(true);
    try {
      await setPassword(uuid, pw);
      onDone();
    } catch (e) {
      setError("설정 실패. 다시 시도해 주세요.");
    }
    setLoading(false);
  };
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        color: "#1e293b",
        fontFamily:
          "'Pretendard','Apple SD Gothic Neo',-apple-system,sans-serif",
        maxWidth: 420,
        margin: "0 auto",
        padding: "3rem 1.5rem 2rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <p
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: ".22em",
          color: "#6366f1",
          margin: "0 0 14px",
        }}
      >
        3 / 3 — 비밀번호 설정
      </p>
      <h2 style={{ fontSize: 24, fontWeight: 800, margin: "0 0 8px" }}>
        비밀번호 설정
      </h2>
      <p style={{ color: "#64748b", fontSize: 14, margin: "0 0 8px" }}>
        재접속 시 사용할 비밀번호를 설정해 주세요.
      </p>
      <p style={{ color: "#94a3b8", fontSize: 12, margin: "0 0 24px" }}>
        닉네임: <strong style={{ color: "#6366f1" }}>{nick}</strong>
      </p>
      <input
        value={pw}
        onChange={(e) => setPw(e.target.value)}
        type="password"
        placeholder="비밀번호 (6자 이상)"
        style={inputStyle}
      />
      <input
        value={pw2}
        onChange={(e) => setPw2(e.target.value)}
        type="password"
        placeholder="비밀번호 확인"
        style={inputStyle}
      />
      {pw.length > 0 && pw.length < 6 && (
        <p style={{ fontSize: 12, color: "#f43f5e", marginBottom: 10 }}>
          6자 이상 입력해 주세요
        </p>
      )}
      {pw.length >= 6 && pw2.length > 0 && !match && (
        <p style={{ fontSize: 12, color: "#f43f5e", marginBottom: 10 }}>
          비밀번호가 일치하지 않습니다
        </p>
      )}
      {match && (
        <p style={{ fontSize: 12, color: "#34d399", marginBottom: 10 }}>
          ✓ 비밀번호 일치
        </p>
      )}
      {error && (
        <p style={{ fontSize: 12, color: "#f43f5e", marginBottom: 10 }}>
          {error}
        </p>
      )}
      <button
        disabled={!match || loading}
        onClick={submit}
        style={{
          width: "100%",
          padding: "15px 0",
          borderRadius: 14,
          border: "none",
          fontWeight: 700,
          fontSize: 15,
          cursor: match ? "pointer" : "not-allowed",
          background: match
            ? "linear-gradient(135deg,#6366f1,#4f46e5)"
            : "rgba(99,102,241,0.15)",
          color: match ? "#fff" : "#475569",
          fontFamily: "inherit",
        }}
      >
        {loading ? "설정 중..." : "완료"}
      </button>
    </div>
  );
}

function LoginScreen({ onLogin, onNewUser }) {
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    padding: "14px 18px",
    background: "rgba(0,0,0,0.04)",
    border: "0.5px solid rgba(0,0,0,0.1)",
    borderRadius: 13,
    color: "#1e293b",
    fontSize: 14,
    outline: "none",
    fontFamily: "inherit",
    marginBottom: 10,
  };

  const submit = async () => {
    if (!id || !pw) return;
    setLoading(true);
    setError("");
    try {
      const user = await loginWithPassword(id, pw);
      onLogin(user);
    } catch (e) {
      setLoading(false);
      if (e.message === "USER_NOT_FOUND") setError("등록되지 않은 계정입니다");
      else if (e.message === "WRONG_PASSWORD")
        setError("비밀번호가 틀렸습니다");
      else setError("로그인 실패. 다시 시도해 주세요.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        color: "#1e293b",
        fontFamily:
          "'Pretendard','Apple SD Gothic Neo',-apple-system,sans-serif",
        maxWidth: 420,
        margin: "0 auto",
        padding: "3rem 1.5rem 2rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: 46,
          height: 46,
          borderRadius: 15,
          background: "rgba(99,102,241,0.12)",
          border: "0.5px solid rgba(99,102,241,0.25)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "1.5rem",
        }}
      >
        <Cross size={22} />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          margin: "0 0 10px",
        }}
      >
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: ".22em",
            color: "#6366f1",
          }}
        >
          PEER:AGE
        </span>
        <span style={{ fontSize: 11, color: "#94a3b8" }}>·</span>
        <span style={{ fontSize: 11, fontWeight: 600, color: "#64748b" }}>
          동료 시대
        </span>
      </div>
      <h2 style={{ fontSize: 24, fontWeight: 800, margin: "0 0 8px" }}>
        로그인
      </h2>
      <p style={{ color: "#64748b", fontSize: 14, margin: "0 0 24px" }}>
        기관 이메일로 로그인하세요
      </p>

      <input
        value={id}
        onChange={(e) => setId(e.target.value)}
        type="text"
        placeholder="기관 이메일"
        style={inputStyle}
      />
      <input
        value={pw}
        onChange={(e) => setPw(e.target.value)}
        type="password"
        placeholder="비밀번호"
        onKeyDown={(e) => e.key === "Enter" && submit()}
        style={inputStyle}
      />

      {error && (
        <div
          style={{
            background: "rgba(244,63,94,0.06)",
            border: "0.5px solid rgba(244,63,94,0.2)",
            borderRadius: 11,
            padding: "10px 13px",
            marginBottom: 12,
            fontSize: 12,
            color: "#f43f5e",
          }}
        >
          {error}
        </div>
      )}

      <button
        disabled={!id || !pw || loading}
        onClick={submit}
        style={{
          width: "100%",
          padding: "15px 0",
          borderRadius: 14,
          border: "none",
          fontWeight: 700,
          fontSize: 15,
          cursor: id && pw ? "pointer" : "not-allowed",
          background:
            id && pw
              ? "linear-gradient(135deg,#6366f1,#4f46e5)"
              : "rgba(99,102,241,0.15)",
          color: id && pw ? "#fff" : "#475569",
          fontFamily: "inherit",
          marginBottom: 16,
        }}
      >
        {loading ? "확인 중..." : "로그인"}
      </button>

      <button
        onClick={onNewUser}
        style={{
          background: "none",
          border: "none",
          color: "#6366f1",
          fontSize: 13,
          cursor: "pointer",
          fontFamily: "inherit",
          textDecoration: "underline",
        }}
      >
        처음 이용하시나요? 직원 인증하기
      </button>
    </div>
  );
}

function DoctorChangeModal({ uuid, nick, hospital, onClose }) {
  const h = H[hospital] || H.amc;
  const [type, setType] = useState(""); // "add" | "remove" | "update"
  const [docName, setDocName] = useState("");
  const [docDept, setDocDept] = useState("");
  const [docSpec, setDocSpec] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    background: "rgba(0,0,0,0.03)",
    border: "0.5px solid rgba(0,0,0,0.08)",
    borderRadius: 11,
    padding: "11px 13px",
    color: "#1e293b",
    fontSize: 13,
    fontFamily: "inherit",
    outline: "none",
    marginBottom: 10,
  };

  const canSubmit = type && docName.trim().length > 0 && !loading;

  const submit = async () => {
    if (!canSubmit) return;
    setLoading(true);
    try {
      await saveDoctorChangeRequest({
        type,
        hospital,
        docName: docName.trim(),
        docDept: docDept.trim(),
        docSpec: docSpec.trim(),
        reason: reason.trim(),
        requesterUuid: uuid,
        requesterNick: nick,
      });
      setSent(true);
    } catch (e) {
      console.error("정보 공유 실패:", e);
      setLoading(false);
    }
  };

  if (sent)
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.88)",
          zIndex: 300,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 420,
            background: "#fff",
            borderRadius: "20px 20px 0 0",
            padding: "2rem 1.5rem 3rem",
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: 56, marginBottom: 16 }}>🙏</div>
          <p
            style={{
              fontSize: 17,
              fontWeight: 800,
              color: "#1e293b",
              margin: "0 0 10px",
            }}
          >
            정보 공유 감사합니다!
          </p>
          <p
            style={{
              fontSize: 14,
              color: "#64748b",
              margin: "0 0 24px",
              lineHeight: 1.6,
            }}
          >
            동료들에게 더 정확한 정보를
            <br />
            전달할 수 있게 도와주셨어요
          </p>
          <button
            onClick={onClose}
            style={{
              width: "100%",
              padding: "14px 0",
              borderRadius: 13,
              border: "none",
              fontWeight: 700,
              fontSize: 14,
              cursor: "pointer",
              fontFamily: "inherit",
              background: `linear-gradient(135deg,${h.color},#6366f1)`,
              color: "#fff",
            }}
          >
            확인
          </button>
        </div>
      </div>
    );

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.88)",
        zIndex: 300,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: "20px 20px 0 0",
          padding: "1.5rem 1.5rem 3rem",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 18,
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: 16,
              fontWeight: 800,
              color: "#1e293b",
            }}
          >
            🤝 동료 정보 공유
          </h3>
          <button
            onClick={onClose}
            style={{
              background: "rgba(0,0,0,0.04)",
              border: "none",
              borderRadius: 8,
              padding: 7,
              cursor: "pointer",
              fontSize: 16,
            }}
          >
            ✕
          </button>
        </div>

        <p
          style={{
            fontSize: 13,
            color: "#64748b",
            margin: "0 0 18px",
            lineHeight: 1.6,
          }}
        >
          {H[hospital]?.short} 동료 정보를 알려주세요 🙌
        </p>

        {/* 유형 선택 */}
        <p
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#475569",
            letterSpacing: ".1em",
            marginBottom: 7,
          }}
        >
          어떤 정보인가요?
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            marginBottom: 18,
          }}
        >
          {[
            { v: "add", label: "🆕 새 동료가 오셨어요" },
            { v: "remove", label: "🚪 떠나신 동료가 있어요" },
            { v: "update", label: "✏️ 잘못된 정보를 알려드릴게요" },
          ].map((opt) => (
            <button
              key={opt.v}
              onClick={() => setType(opt.v)}
              style={{
                padding: "12px 14px",
                borderRadius: 11,
                textAlign: "left",
                border: `0.5px solid ${
                  type === opt.v ? h.color + "60" : "rgba(0,0,0,0.1)"
                }`,
                background:
                  type === opt.v ? `${h.color}10` : "rgba(0,0,0,0.02)",
                color: type === opt.v ? h.color : "#475569",
                fontSize: 13,
                fontWeight: type === opt.v ? 700 : 600,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              {opt.label}
            </button>
          ))}
        </div>

        {type && (
          <>
            <p
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#475569",
                letterSpacing: ".1em",
                marginBottom: 7,
              }}
            >
              의사 이름 <span style={{ color: "#f43f5e" }}>*</span>
            </p>
            <input
              value={docName}
              onChange={(e) => setDocName(e.target.value)}
              placeholder="예) 김XX"
              maxLength={20}
              style={inputStyle}
            />

            {type !== "remove" && (
              <>
                <p
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#475569",
                    letterSpacing: ".1em",
                    marginBottom: 7,
                    marginTop: 8,
                  }}
                >
                  진료과
                </p>
                <input
                  value={docDept}
                  onChange={(e) => setDocDept(e.target.value)}
                  placeholder="예) 내과, 외과"
                  maxLength={30}
                  style={inputStyle}
                />

                <p
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#475569",
                    letterSpacing: ".1em",
                    marginBottom: 7,
                    marginTop: 8,
                  }}
                >
                  전문분야
                </p>
                <input
                  value={docSpec}
                  onChange={(e) => setDocSpec(e.target.value)}
                  placeholder="예) 당뇨, 갑상선 (쉼표로 구분)"
                  maxLength={100}
                  style={inputStyle}
                />
              </>
            )}

            <p
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#475569",
                letterSpacing: ".1em",
                marginBottom: 7,
                marginTop: 8,
              }}
            >
              추가 메모{" "}
              <span style={{ color: "#94a3b8", fontWeight: 400 }}>(선택)</span>
            </p>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="추가 정보가 있다면 적어주세요"
              rows={2}
              maxLength={200}
              style={{ ...inputStyle, resize: "none" }}
            />

            <button
              disabled={!canSubmit}
              onClick={submit}
              style={{
                width: "100%",
                padding: "14px 0",
                borderRadius: 13,
                border: "none",
                fontWeight: 700,
                fontSize: 14,
                fontFamily: "inherit",
                marginTop: 8,
                background: canSubmit
                  ? `linear-gradient(135deg,${h.color},#6366f1)`
                  : "rgba(99,102,241,0.15)",
                color: canSubmit ? "#fff" : "#475569",
                cursor: canSubmit ? "pointer" : "not-allowed",
              }}
            >
              {loading ? "전송 중..." : "정보 공유하기 🙌"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

function ContactScreen({ uuid, nick, hospital, onClose }) {
  const h = H[hospital] || H.amc;
  const [message, setMessage] = useState("");
  const [contact, setContact] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [myMessages, setMyMessages] = useState([]);
  const [tab, setTab] = useState("write");

  useEffect(() => {
    if (!uuid) return;
    getMyMessages(uuid)
      .then((msgs) => {
        setMyMessages(
          msgs.sort((a, b) => b.createdAt?.toDate?.() - a.createdAt?.toDate?.())
        );
      })
      .catch((e) => console.error(e));
  }, [uuid]);

  const submit = async () => {
    if (!message.trim()) return;
    setLoading(true);
    try {
      await saveMessage(uuid, nick, hospital, message, contact);
      setSent(true);
      const msgs = await getMyMessages(uuid);
      setMyMessages(
        msgs.sort((a, b) => b.createdAt?.toDate?.() - a.createdAt?.toDate?.())
      );
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.88)",
        zIndex: 300,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: "20px 20px 0 0",
          padding: "1.5rem 1.5rem 3rem",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 18,
          }}
        >
          <div style={{ display: "flex", gap: 12 }}>
            {[
              { id: "write", l: "문의하기" },
              { id: "history", l: "내 문의" },
            ].map((t) => (
              <button
                key={t.id}
                onClick={() => {
                  setTab(t.id);
                  setSent(false);
                }}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: 14,
                  fontWeight: 700,
                  cursor: "pointer",
                  color: tab === t.id ? h.color : "#94a3b8",
                  borderBottom:
                    tab === t.id
                      ? `2px solid ${h.color}`
                      : "2px solid transparent",
                  paddingBottom: 4,
                  fontFamily: "inherit",
                }}
              >
                {t.l}
              </button>
            ))}
          </div>
          <button
            onClick={onClose}
            style={{
              background: "rgba(0,0,0,0.04)",
              border: "none",
              borderRadius: 8,
              padding: 7,
              cursor: "pointer",
              fontSize: 16,
            }}
          >
            ✕
          </button>
        </div>

        {tab === "write" && !sent && (
          <>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="문의 내용을 입력해 주세요"
              rows={4}
              style={{
                width: "100%",
                boxSizing: "border-box",
                background: "rgba(0,0,0,0.03)",
                border: "0.5px solid rgba(0,0,0,0.08)",
                borderRadius: 11,
                padding: "11px 13px",
                color: "#1e293b",
                fontSize: 13,
                fontFamily: "inherit",
                resize: "none",
                outline: "none",
                marginBottom: 12,
              }}
            />
            <p style={{ fontSize: 11, color: "#94a3b8", marginBottom: 8 }}>
              답변 받을 연락처 (선택)
            </p>
            <input
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              placeholder="기관 이메일"
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "12px 14px",
                background: "rgba(0,0,0,0.03)",
                border: "0.5px solid rgba(0,0,0,0.08)",
                borderRadius: 11,
                color: "#1e293b",
                fontSize: 13,
                fontFamily: "inherit",
                outline: "none",
                marginBottom: 16,
              }}
            />
            <button
              disabled={!message.trim() || loading}
              onClick={submit}
              style={{
                width: "100%",
                padding: "14px 0",
                borderRadius: 13,
                border: "none",
                fontWeight: 700,
                fontSize: 14,
                cursor: message.trim() ? "pointer" : "not-allowed",
                background: message.trim()
                  ? `linear-gradient(135deg,${h.color},#6366f1)`
                  : "rgba(99,102,241,0.15)",
                color: message.trim() ? "#fff" : "#475569",
                fontFamily: "inherit",
              }}
            >
              {loading ? "전송 중..." : "문의 전송"}
            </button>
          </>
        )}

        {tab === "write" && sent && (
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
            <p
              style={{
                fontSize: 16,
                fontWeight: 700,
                color: "#1e293b",
                margin: "0 0 6px",
              }}
            >
              문의가 접수되었습니다
            </p>
            <p style={{ fontSize: 12, color: "#64748b", margin: "0 0 20px" }}>
              답변은 앱에서 확인하실 수 있습니다
            </p>
            <button
              onClick={() => {
                setSent(false);
                setMessage("");
                setContact("");
                setTab("history");
              }}
              style={{
                padding: "10px 24px",
                borderRadius: 10,
                border: "none",
                background: `${h.color}18`,
                color: h.color,
                fontWeight: 700,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              내 문의 보기
            </button>
          </div>
        )}

        {tab === "history" && (
          <div>
            {myMessages.length === 0 ? (
              <p
                style={{
                  color: "#94a3b8",
                  fontSize: 13,
                  textAlign: "center",
                  padding: "20px 0",
                }}
              >
                문의 내역이 없습니다
              </p>
            ) : (
              myMessages.map((m) => {
                const d = m.createdAt?.toDate?.();
                const dateStr = d ? d.toLocaleDateString("ko-KR") : "";
                return (
                  <div
                    key={m.id}
                    style={{
                      background: "rgba(0,0,0,0.03)",
                      borderRadius: 12,
                      padding: 14,
                      marginBottom: 10,
                    }}
                  >
                    <p
                      style={{
                        fontSize: 11,
                        color: "#94a3b8",
                        margin: "0 0 6px",
                      }}
                    >
                      {dateStr}
                    </p>
                    <p
                      style={{
                        fontSize: 13,
                        color: "#1e293b",
                        margin: "0 0 10px",
                      }}
                    >
                      {m.message}
                    </p>
                    {m.answer ? (
                      <div
                        style={{
                          background: `${h.color}0a`,
                          border: `0.5px solid ${h.color}25`,
                          borderRadius: 10,
                          padding: "10px 12px",
                        }}
                      >
                        <p
                          style={{
                            fontSize: 11,
                            color: h.color,
                            fontWeight: 700,
                            margin: "0 0 4px",
                          }}
                        >
                          관리자 답변
                        </p>
                        <p
                          style={{ fontSize: 13, color: "#1e293b", margin: 0 }}
                        >
                          {m.answer}
                        </p>
                      </div>
                    ) : (
                      <p style={{ fontSize: 11, color: "#94a3b8", margin: 0 }}>
                        답변 대기 중...
                      </p>
                    )}
                  </div>
                );
              })
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function ThankYouScreen({ onClose }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.88)",
        zIndex: 400,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: "20px 20px 0 0",
          padding: "2rem 1.5rem 3rem",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 48, marginBottom: 16 }}>🙏</div>
        <p
          style={{
            fontSize: 18,
            fontWeight: 800,
            color: "#1e293b",
            margin: "0 0 10px",
          }}
        >
          추천해주셔서 감사합니다
        </p>
        <p
          style={{
            fontSize: 14,
            color: "#64748b",
            margin: "0 0 20px",
            lineHeight: 1.7,
          }}
        >
          좋은 정보로 보답하겠습니다 ✨<br />
          <span style={{ fontSize: 12, color: "#94a3b8" }}>
            오늘의 메뉴도 둘러보세요 🍱
          </span>
        </p>
        <button
          onClick={onClose}
          style={{
            width: "100%",
            padding: "14px 0",
            borderRadius: 13,
            border: "none",
            fontWeight: 700,
            fontSize: 14,
            cursor: "pointer",
            background: "linear-gradient(135deg,#6366f1,#4f46e5)",
            color: "#fff",
            fontFamily: "inherit",
          }}
        >
          확인
        </button>
      </div>
    </div>
  );
}

export default function App() {
  const [step, setStep] = useState("loading");
  const [hospital, setHospital] = useState("amc");
  const [nick, setNick] = useState("");
  const [uuid, setUuid] = useState("");
  const [waitlistHosp, setWaitlistHosp] = useState("");
  const [authValue, setAuthValue] = useState("");
  const [authType, setAuthType] = useState("");
  const [showThankYou, setShowThankYou] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-RYBQR0KSGY";
    script.async = true;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", "G-RYBQR0KSGY");
    const link = document.createElement("link");
    link.rel = "manifest";
    link.href = "/manifest.json";
    document.head.appendChild(link);
    const meta1 = document.createElement("meta");
    meta1.name = "apple-mobile-web-app-capable";
    meta1.content = "yes";
    document.head.appendChild(meta1);
    const meta2 = document.createElement("meta");
    meta2.name = "apple-mobile-web-app-status-bar-style";
    meta2.content = "default";
    document.head.appendChild(meta2);
    const meta3 = document.createElement("meta");
    meta3.name = "apple-mobile-web-app-title";
    meta3.content = "PEER:AGE";
    document.head.appendChild(meta3);
    const meta4 = document.createElement("meta");
    meta4.name = "theme-color";
    meta4.content = "#6366f1";
    document.head.appendChild(meta4);
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem("peeriage_user");
    if (saved) {
      try {
        const user = JSON.parse(saved);
        if (user.uuid && user.nick && user.hospital) {
          setUuid(user.uuid);
          setNick(user.nick);
          setHospital(user.hospital);
          setStep(user.pwHash ? "login" : "setpassword");
          return;
        }
      } catch (e) {}
    }
    setStep("main");
  }, []);

  const onRoleDone = async (role, roleNum) => {
    try {
      const user = await registerOrRestoreUser(
        authValue,
        authType,
        role,
        roleNum,
        hospital
      );
      setUuid(user.uuid);
      setNick(user.nick);
      if (user.hasPassword) {
        localStorage.setItem(
          "peeriage_user",
          JSON.stringify({ uuid: user.uuid, nick: user.nick, hospital })
        );
        setStep("dashboard");
      } else {
        setStep("setpassword");
      }
    } catch (e) {
      console.error("사용자 등록 실패:", e);
      setNick(`${role} ${roleNum}`);
      setStep("setpassword");
    }
  };

  const onPasswordSet = () => {
    localStorage.setItem(
      "peeriage_user",
      JSON.stringify({ uuid, nick, hospital, pwHash: true })
    );
    setStep("dashboard");
  };

  const onLogin = (user) => {
    setUuid(user.uuid);
    setNick(user.nick);
    if (user.hospital) setHospital(user.hospital);
    localStorage.setItem(
      "peeriage_user",
      JSON.stringify({
        uuid: user.uuid,
        nick: user.nick,
        hospital: user.hospital || hospital,
        pwHash: true,
      })
    );
    setStep("dashboard");
  };

  const onLogout = () => {
    localStorage.removeItem("peeriage_user");
    setStep("login");
  };

  if (step === "main")
    return (
      <MainScreen
        onStart={() => setStep("gps")}
        onLogin={() => setStep("login")}
      />
    );
  if (step === "login")
    return <LoginScreen onLogin={onLogin} onNewUser={() => setStep("gps")} />;
  if (step === "waitlist")
    return (
      <WaitlistScreen
        hospitalName={waitlistHosp}
        onBack={() => setStep("gps")}
      />
    );
  if (step === "gps")
    return (
      <GpsScreen
        onConfirm={(h) => {
          setHospital(h);
          setStep("auth");
        }}
        onWaitlist={(name) => {
          setWaitlistHosp(name);
          setStep("waitlist");
        }}
      />
    );
  if (step === "auth")
    return (
      <AuthScreen
        hospital={hospital}
        onDone={(value, type) => {
          setAuthValue(value);
          setAuthType(type);
          setStep("role");
        }}
      />
    );
  if (step === "role")
    return <RoleSelect hospital={hospital} onDone={onRoleDone} />;
  if (step === "setpassword")
    return (
      <SetPasswordScreen
        uuid={uuid}
        nick={nick}
        hospital={hospital}
        onDone={onPasswordSet}
      />
    );
  if (step === "dashboard")
    return (
      <>
        <Dashboard
          hospital={hospital}
          nick={nick}
          uuid={uuid}
          onLogout={onLogout}
          onThankYou={() => setShowThankYou(true)}
        />
        {showThankYou && (
          <ThankYouScreen onClose={() => setShowThankYou(false)} />
        )}
      </>
    );
  return null;
}
